import {
  Compiler,
  EventEmitter,
  Injectable,
  Injector,
  NgModuleFactory,
} from '@angular/core';
import {
  HttpClient,
  HttpEvent,
  HttpHeaders,
  HttpRequest,
} from '@angular/common/http';
import { BehaviorSubject, Observable, Subject, ReplaySubject, of } from 'rxjs';
import {
  AccountGrainInfo,
  Calendar,
  Calender,
  Category,
  Channel,
  Client,
  Distributor,
  FbChannel,
  FbForecast,
  Item,
  ItemAccount,
  Measure,
  Source,
  UserFbForecast,
  Version,
} from '@algomusinc/domain';
import { Form } from '@angular/forms';
import { EnvironmentService } from '../service/service.module';
import { LocalstorageService } from './localstorage.service';

var mouseDown = 0;
document.body.onmousedown = function () {
  mouseDown = 1;
};
document.body.onmouseup = function () {
  mouseDown = 0;
};
@Injectable({
  providedIn: 'root',
})
export class ConfigurationService {
  environment = EnvironmentService.environment;

  // Module State Flags
  isMfpLoaded = false;
  isPdmLoaded = false;
  isReportingLoaded = false;
  isCpmLoaded = false;
  isFbLoaded = false;
  isEssLoaded = false;
  isDataPortalLoaded = false;
  isStockPlannerLoaded = false;
  isMsLoaded = false;
  isItemLoaded = false;
  isAuthLoaded = false;
  isLayoutLoaded = false;
  isPromotionLoaded = false;
  isGenAI = false;
  isAppInsightLoaded = false;
  isSegmentationLoaded = false;
  isClusteringLoaded = false;
  isForecastEngineLoaded = false;
  isSkylightOrderCreationModuleLoaded = false;
  isSkylightInventoryManagerModuleLoaded = false;
  isSkylightOrderManagerModuleLoaded = false;
  POGManagerModuleLoaded = false
  isSkylightForecastManagerModuleLoaded = false;
  isSkylightMastersModuleLoaded = false;
  isQuickpitchModuleLoaded = false;
  isProcurementModuleLoaded = false;
  isPlanogramOptimizerLoaded = false;
  isCarpartsModuleLoaded = false;
  isBestBuyManagerModule = false;
  isMultiUserMessagingModuleLoaded = false;
  isHierarchyLoaded = false;
  isSkylightAdminModuleLoaded = false;
  isPriceAndPromoPlannerLoaded = false;
  isExceptionManagementLoaded = false;
  isMasterLoaded = false;
  isConfigLoaded = false;
  isOrderManagementLoaded = false;
  isJourneyLoaded = false;
  isDynamicComponentBuilderModule = false;
  isApparelModuleLoaded = false;
  tempForecastList: any = [];
  regTempForecastList: any = [];
  colabTempForecastList: any = [];
  retailCalendarData: any[] = [];
  // Subjects
  public editColumnSubject: Subject<any> = new Subject();
  public removeColumnSubject: Subject<any> = new Subject();
  public sendBotAlert: Subject<any> = new Subject();
  public openFavouriteSubject = new ReplaySubject<any>();
  public simulationSubject = new BehaviorSubject<any>(null);
  public journeyUpdate = new BehaviorSubject<any>(null);
  public favouriteRemoveSubject = new BehaviorSubject<any>(null);
  public menuRendererSubject = new BehaviorSubject<any>(null);
  public takeScreenshot = new BehaviorSubject<any>(null);
  public promotionListSubject = new BehaviorSubject<any>(null);
  public itemMasterListSubject = new BehaviorSubject<any>(null);
  public menuListSubject = new BehaviorSubject<any>(null);
  public languageSubject = new BehaviorSubject<any>(null);
  public updateListing = new BehaviorSubject<any>(null);
  public removeMenu = new BehaviorSubject<any>(null);
  public yearListUpdated = new BehaviorSubject<any>(null);
  public savedPlannerOpened = new BehaviorSubject<any>(null);
  public savedItemPlannerOpened = new BehaviorSubject<any>(null);
  public updateForecastList = new BehaviorSubject<any>(null);
  public updateForecastListRegional = new BehaviorSubject<any>(null);
  public updateMethodManagerList = new BehaviorSubject<any>(null);
  public updateMethodManagerListRegional = new BehaviorSubject<any>(null);
  public updateGridList = new BehaviorSubject<any>(null);
  public openImportDialog = new BehaviorSubject<any>(null);
  public updateWeeks = new BehaviorSubject<any>(null);
  public plannerReportRenderer = new BehaviorSubject<any>(null);
  public shareJourneyNotification = new BehaviorSubject<any>(null);
  public shareJourneyNotificationTotalCount = new BehaviorSubject<any>(null);
  public tenantUpdated = new BehaviorSubject<any>(null);
  public shareJourney = new EventEmitter<any>();
  public refreshApprovalGrid = new EventEmitter<any>();
  public checkJourneyNotification = new EventEmitter<any>();
  public getNotesList = new EventEmitter<any>();
  public getCurrencyList = new EventEmitter<any>();
  // save note as comment
  public noteAddToComment = new Subject();
  // Journey Events
  public executeJourneyEvent = new BehaviorSubject<any>(null);
  public taskViewEvent = new BehaviorSubject<any>(false);
  public reportLoadedEvent = new Subject();
  public refreshMenu = new BehaviorSubject<any>(null);
  // Notification signalR Subject
  public notificationEvent: Subject<any> = new Subject<any>();
  // Journey Events
  // Observables
  public openFavouriteSubject$ = this.openFavouriteSubject.asObservable();
  public favouriteListSubject = new Subject();
  public favouriteListSubject$ = this.favouriteListSubject.asObservable();
  public kpiListSubject = new Subject();
  public kpiListSubject$ = this.kpiListSubject.asObservable();
  public graphListSubject = new Subject();
  public graphListSubject$ = this.graphListSubject.asObservable();
  public simulationSubject$ = this.simulationSubject.asObservable();
  public favouriteRemoveSubject$ = this.favouriteRemoveSubject.asObservable();
  public menuRendererSubject$ = this.menuRendererSubject.asObservable();
  public takeScreenshot$ = this.takeScreenshot.asObservable();
  public promotionListSubject$ = this.promotionListSubject.asObservable();
  public itemMasterListSubject$ = this.itemMasterListSubject.asObservable();
  public menuListSubject$ = this.menuListSubject.asObservable();
  public languageSubject$ = this.languageSubject.asObservable();
  public updateListing$ = this.updateListing.asObservable();
  public removeMenu$ = this.removeMenu.asObservable();
  public yearListUpdated$ = this.yearListUpdated.asObservable();
  public savedPlannerOpened$ = this.savedPlannerOpened.asObservable();
  public updateForecastList$ = this.updateForecastList.asObservable();
  public updateGridList$ = this.updateGridList.asObservable();
  public openImportDialog$ = this.openImportDialog.asObservable();
  public updateForecastListRegional$ =
    this.updateForecastListRegional.asObservable();
  public updateMethodManagerList$ = this.updateMethodManagerList.asObservable();
  public updateMethodManagerListRegional$ =
    this.updateMethodManagerListRegional.asObservable();
  public updateWeeks$ = this.updateWeeks.asObservable();
  public itemModel = new Item(new Item());
  public accountModel: any = new ItemAccount(new ItemAccount());
  public roleModel: any = '';
  public teamsModel: any = '';
  public menuList: any[] = [];
  public promotionModel: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  public onCalculate: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  public homeBase: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  public matCollapse: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  public deleteMenuByGuid: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  public openScreenBySelector: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  public emptyAccordionView: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  public execDashboardEvent: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  public openElementFromComment: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  public ViewPlannerKPI: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  public ViewScreenFromEmail: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  public dashboardViewList: Array<any> = new Array();;
  public gridList: any[] = [];
  public plannerInstanceList = [];
  public agGridClass = 'ag-theme-material';
  public orderPageEvent = new Subject();
  public sidebarMenus: Array<any> = new Array();
  constructor(public http: HttpClient, public storage: LocalstorageService) { }
  get isMouseDown() {
    return mouseDown;
  }
  get PlannerReports() {
    return this.menuList.filter((row: any) => row.parentId === 195);
  }
  setMousedown(value: any) {
    mouseDown = value;
  }
  /* Set Subjects for HEADER COLUMN EDIT/REMOVE */

  setEditColumnSubject = (value: any) => {
    this.editColumnSubject.next(value);
  };
  setRemoveColumnSubject = (value: any) => {
    this.removeColumnSubject.next(value);
  };
  getEditColumnSubject = () => this.editColumnSubject.asObservable();
  getRemoveColumnSubject = () => this.removeColumnSubject.asObservable();
  /* Calender CRUD Model */

  addCalender = (calender: Calender) => {
    return this.http.post<any>(`${this.environment.AppCalender}/add`, calender);
  };
  updateCalender = (calender: Calender) => {
    return this.http.put(`${this.environment.AppCalender}/update`, calender);
  };
  activateCalender = (calender: Calender) => {
    return this.http.put(`${this.environment.AppCalender}/activate`, calender);
  };
  getGetCalenderEventGroup = (params: any) => {
    return this.http.get<any>(
      `${this.environment.AppCalender}/getGetCalenderEventGroup`,
      { params }
    );
  };

  /* Category CRUD Model */

  addCategory = (category: Category) => {
    return this.http.post<any>(`${this.environment.AppCategory}/add`, category);
  };
  updateCategory = (category: Category) => {
    return this.http.put(`${this.environment.AppCategory}/update`, category);
  };
  activateCategory = (category: any) => {
    return this.http.put(`${this.environment.AppCategory}/activate`, category);
  };
  searchCategory = (searchText: string) => {
    return this.http.get<any>(
      `${this.environment.AppCategory}/search?search=${searchText}`
    );
  };
  getCategory = (categoryId: string) => {
    return this.http.get<any>(
      `${this.environment.AppCategory}/get?CategoryId=${categoryId}`
    );
  };
  getAllCategories = (params: any) => {
    return this.http.get<any>(`${this.environment.AppCategory}/getall`, {
      params,
    });
  };
  getCategoryList = (params: any) => {
    return this.http.get<any>(`${this.environment.AppCategory}/getlist`, {
      params,
    });
  };

  /* Channel CRUD Model */

  addChannel = (channel: Channel) => {
    return this.http.post<any>(`${this.environment.AppChannel}/add`, channel);
  };
  updateChannel = (channel: Channel) => {
    return this.http.put(`${this.environment.AppChannel}/update`, channel);
  };
  activateChannel = (channel: Channel) => {
    return this.http.put(`${this.environment.AppChannel}/activate`, channel);
  };
  getChannel = (ChannelId: string) => {
    return this.http.get<any>(
      `${this.environment.AppChannel}/get?ChannelId=${ChannelId}`
    );
  };
  getAllChannels = (params: any) => {
    return this.http.get<any>(`${this.environment.AppChannel}/getall`, {
      params,
    });
  };
  getChannelList = (params: any) => {
    return this.http.get<any>(`${this.environment.AppChannel}/getlist`, params);
  };

  /* Client CRUD Model */

  addClient = (client: Client) => {
    return this.http.post<any>(`${this.environment.AppClient}/add`, client);
  };
  updateClient = (client: Client) => {
    return this.http.put(`${this.environment.AppClient}/update`, client);
  };
  activateClient = (client: Client) => {
    return this.http.put(`${this.environment.AppClient}/activate`, client);
  };
  getClient = (ClientId: string) => {
    return this.http.get<any>(
      `${this.environment.AppClient}/get?ClientId=${ClientId}`
    );
  };
  getAllClients = (params: any) => {
    return this.http.get<any>(`${this.environment.AppClient}/getall`, params);
  };
  getClientList = (params: any) => {
    return this.http.get<any>(`${this.environment.AppClient}/getlist`, params);
  };
  /* Distributor CRUD Model */

  addDistributor = (distributor: Distributor) => {
    return this.http.post<any>(
      `${this.environment.AppDistributor}/add`,
      distributor
    );
  };
  updateDistributor = (distributor: Distributor) => {
    return this.http.put(
      `${this.environment.AppDistributor}/update`,
      distributor
    );
  };
  activateDistributor = (distributor: Distributor) => {
    return this.http.put(
      `${this.environment.AppDistributor}/activate`,
      distributor
    );
  };
  getDistributor = (DistributorId: string) => {
    return this.http.get<any>(
      `${this.environment.AppDistributor}/get?DistributorId=${DistributorId}`
    );
  };
  getAllDistributors = (params: any) => {
    return this.http.get<any>(`${this.environment.AppDistributor}/getall`, {
      params,
    });
  };
  getDistributorList = (params: any) => {
    return this.http.get<any>(
      `${this.environment.AppDistributor}/getlist`,
      params
    );
  };

  /* Distributor CRUD Model */

  addForm = (form: Form) => {
    return this.http.post<any>(`${this.environment.AppForms}/add`, form);
  };
  updateForm = (form: Form) => {
    return this.http.put(`${this.environment.AppForms}/update`, form);
  };
  activateForm = (form: Form) => {
    return this.http.put(`${this.environment.AppForms}/activate`, form);
  };
  getForm = (FormId: string) => {
    return this.http.get<any>(
      `${this.environment.AppForms}/get?FormId=${FormId}`
    );
  };
  getAllForms = (params: any) => {
    return this.http.get<any>(`${this.environment.AppForms}/getall`, params);
  };
  getFormList = (params: any) => {
    return this.http.get<any>(`${this.environment.AppForms}/getlist`, params);
  };
  /* Sourcing CRUD Model */

  addSource = (source: Source) => {
    return this.http.post<any>(`${this.environment.AppSource}/add`, source);
  };
  updateSource = (source: Source) => {
    return this.http.put(`${this.environment.AppSource}/update`, source);
  };
  activateSource = (source: Source) => {
    return this.http.put(`${this.environment.AppSource}/activate`, source);
  };
  getSource = (SourceId: string) => {
    return this.http.get<any>(
      `${this.environment.AppSource}/get?SourceId=${SourceId}`
    );
  };
  getAllSources = (params: any) => {
    return this.http.get<any>(`${this.environment.AppSource}/getall`, {
      params,
    });
  };
  getSourceList = (params: any) => {
    return this.http.get<any>(`${this.environment.AppSource}/getlist`, params);
  };
  /* Goal CRUD Model */

  addGoal = (goal: any) => {
    return this.http.post<any>(`${this.environment.AppGoal}/add`, goal);
  };
  updateGoal = (goal: any) => {
    return this.http.put(`${this.environment.AppGoal}/update`, goal);
  };
  activateGoalType = (goal: any) => {
    return this.http.put(`${this.environment.AppGoalType}/activate`, goal);
  };
  getGoalByGoalId = (goalId: any) => {
    return this.http.get<any>(
      `${this.environment.AppGoal}/get?goalId=${goalId}`
    );
  };
  getGoalList = (params: any) => {
    return this.http.get<any>(`${this.environment.AppGoal}/getlist`, {
      params,
    });
  };
  /* Source Mix Form CRUD Model */

  addSourceMixForm = (SourceMixForm: any) => {
    return this.http.post<any>(
      `${this.environment.AppSourceMixForm}/add`,
      SourceMixForm
    );
  };
  updateSourceMixForm = (SourceMixForm: any) => {
    return this.http.put(
      `${this.environment.AppSourceMixForm}/update`,
      SourceMixForm
    );
  };
  activateSourceMixForm = (SourceMixForm: any) => {
    return this.http.put(
      `${this.environment.AppSourceMixForm}/activate`,
      SourceMixForm
    );
  };
  getSourceMixFormBySourceMixFormId = (SourceMixFormId: any) => {
    return this.http.get<any>(
      `${this.environment.AppSourceMixForm}/get?SourceMixFormId=${SourceMixFormId}`
    );
  };
  getSourceMixFormList = (params: any) => {
    return this.http.get<any>(`${this.environment.AppSourceMixForm}/getlist`, {
      params,
    });
  };
  /* Source Mix Form CRUD Model */

  addSourceMixRow = (SourceMixRow: any) => {
    return this.http.post<any>(
      `${this.environment.AppSourceMixRow}/add`,
      SourceMixRow
    );
  };
  updateSourceMixRow = (SourceMixRow: any) => {
    return this.http.put(
      `${this.environment.AppSourceMixRow}/update`,
      SourceMixRow
    );
  };
  activateSourceMixRow = (SourceMixRow: any) => {
    return this.http.put(
      `${this.environment.AppSourceMixRow}/activate`,
      SourceMixRow
    );
  };
  getSourceMixRowBySourceMixRowId = (SourceMixRowId: any) => {
    return this.http.get<any>(
      `${this.environment.AppSourceMixRow}/get?SourceMixRowId=${SourceMixRowId}`
    );
  };
  getSourceMixRowList = (params: any) => {
    return this.http.get<any>(`${this.environment.AppSourceMixRow}/getlist`, {
      params,
    });
  };
  /* Source Mix Form CRUD Model */

  addSourceMixHeader = (SourceMixHeader: any) => {
    return this.http.post<any>(
      `${this.environment.AppSourceMixHeader}/AddSourceMixHeader`,
      SourceMixHeader
    );
  };
  updateSourceMixHeader = (SourceMixHeader: any) => {
    return this.http.put(
      `${this.environment.AppSourceMixHeader}/update`,
      SourceMixHeader
    );
  };
  activateSourceMixHeader = (SourceMixHeader: any) => {
    return this.http.put(
      `${this.environment.AppSourceMixHeader}/activate`,
      SourceMixHeader
    );
  };
  getSourceMixHeaderBySourceMixHeaderId = (SourceMixHeaderId: any) => {
    return this.http.get<any>(
      `${this.environment.AppSourceMixHeader}/get?SourceMixHeaderId=${SourceMixHeaderId}`
    );
  };
  getSourceMixHeaderList = (params: any) => {
    return this.http.get<any>(
      `${this.environment.AppSourceMixHeader}/getlist`,
      {
        params,
      }
    );
  };
  /* Source Mix Form CRUD Model */

  addCategoryMixRow = (CategoryMixRow: any) => {
    return this.http.post<any>(
      `${this.environment.AppCategoryMixRow}/add`,
      CategoryMixRow
    );
  };
  updateCategoryMixRow = (CategoryMixRow: any) => {
    return this.http.put(
      `${this.environment.AppCategoryMixRow}/update`,
      CategoryMixRow
    );
  };
  activateCategoryMixRow = (CategoryMixRow: any) => {
    return this.http.put(
      `${this.environment.AppCategoryMixRow}/activate`,
      CategoryMixRow
    );
  };
  getCategoryMixRowByCategoryMixRowId = (CategoryMixRowId: any) => {
    return this.http.get<any>(
      `${this.environment.AppCategoryMixRow}/get?CategoryMixRowId=${CategoryMixRowId}`
    );
  };
  getCategoryMixRowList = (params: any) => {
    return this.http.get<any>(`${this.environment.AppCategoryMixRow}/getlist`, {
      params,
    });
  };
  /* Source Mix Form CRUD Model */

  addCategoryMixHeader = (CategoryMixHeader: any) => {
    return this.http.post<any>(
      `${this.environment.AppCategoryMixHeader}/AddCategoryMixHeader`,
      CategoryMixHeader
    );
  };
  updateCategoryMixHeader = (CategoryMixHeader: any) => {
    return this.http.put(
      `${this.environment.AppCategoryMixHeader}/update`,
      CategoryMixHeader
    );
  };
  activateCategoryMixHeader = (CategoryMixHeader: any) => {
    return this.http.put(
      `${this.environment.AppCategoryMixHeader}/activate`,
      CategoryMixHeader
    );
  };
  getCategoryMixHeaderByCategoryMixHeaderId = (CategoryMixHeaderId: any) => {
    return this.http.get<any>(
      `${this.environment.AppCategoryMixHeader}/get?CategoryMixHeaderId=${CategoryMixHeaderId}`
    );
  };
  getCategoryMixHeaderList = (params: any) => {
    return this.http.get<any>(
      `${this.environment.AppCategoryMixHeader}/getlist`,
      {
        params,
      }
    );
  };
  /* Source Mix Form CRUD Model */

  addCategoryMixForm = (CategoryMixForm: any) => {
    return this.http.post<any>(
      `${this.environment.AppCategoryMixForm}/add`,
      CategoryMixForm
    );
  };
  updateCategoryMixForm = (CategoryMixForm: any) => {
    return this.http.put(
      `${this.environment.AppCategoryMixForm}/update`,
      CategoryMixForm
    );
  };
  getCategoryMixFormByCategoryMixFormId = (CategoryMixFormId: any) => {
    return this.http.get<any>(
      `${this.environment.AppCategoryMixForm}/get?CategoryMixFormId=${CategoryMixFormId}`
    );
  };
  getCategoryMixFormList = (params: any) => {
    return this.http.get<any>(
      `${this.environment.AppCategoryMixForm}/getlist`,
      {
        params,
      }
    );
  };

  addStoreMixRow = (StoreMixRow: any) => {
    return this.http.post<any>(
      `${this.environment.AppStoreMixRow}/add`,
      StoreMixRow
    );
  };
  updateStoreMixRow = (StoreMixRow: any) => {
    return this.http.put(
      `${this.environment.AppStoreMixRow}/update`,
      StoreMixRow
    );
  };
  activateStoreMixRow = (StoreMixRow: any) => {
    return this.http.put(
      `${this.environment.AppStoreMixRow}/activate`,
      StoreMixRow
    );
  };
  getStoreMixRowByStoreMixRowId = (StoreMixRowId: any) => {
    return this.http.get<any>(
      `${this.environment.AppStoreMixRow}/get?StoreMixRowId=${StoreMixRowId}`
    );
  };
  getStoreMixRowList = (params: any) => {
    return this.http.get<any>(`${this.environment.AppStoreMixRow}/getlist`, {
      params,
    });
  };
  /* Source Mix Form CRUD Model */

  addStoreMixHeader = (StoreMixHeader: any) => {
    return this.http.post<any>(
      `${this.environment.AppStoreMixHeader}/AddNewFormHeader`,
      StoreMixHeader
    );
  };
  updateStoreMixHeader = (StoreMixHeader: any) => {
    return this.http.put(
      `${this.environment.AppStoreMixHeader}/update`,
      StoreMixHeader
    );
  };
  activateStoreMixHeader = (StoreMixHeader: any) => {
    return this.http.put(
      `${this.environment.AppStoreMixHeader}/activate`,
      StoreMixHeader
    );
  };
  getStoreMixHeaderByStoreMixHeaderId = (StoreMixHeaderId: any) => {
    return this.http.get<any>(
      `${this.environment.AppStoreMixHeader}/get?StoreMixHeaderId=${StoreMixHeaderId}`
    );
  };
  getStoreMixHeaderList = (params: any) => {
    return this.http.get<any>(`${this.environment.AppStoreMixHeader}/getlist`, {
      params,
    });
  };
  /* Source Mix Form CRUD Model */

  addStoreMixForm = (StoreMixForm: any) => {
    return this.http.post<any>(
      `${this.environment.AppStoreMixForm}/add`,
      StoreMixForm
    );
  };
  updateStoreMixForm = (StoreMixForm: any) => {
    return this.http.put(
      `${this.environment.AppStoreMixForm}/update`,
      StoreMixForm
    );
  };
  getStoreMixFormByStoreMixFormId = (StoreMixFormId: any) => {
    return this.http.get<any>(
      `${this.environment.AppStoreMixForm}/get?StoreMixFormId=${StoreMixFormId}`
    );
  };
  getStoreMixFormList = (params: any) => {
    return this.http.get<any>(`${this.environment.AppStoreMixForm}/getlist`, {
      params,
    });
  };

  /* Goal CRUD Model */
  addGoalTenureType = (goalTenureType: any) => {
    return this.http.post<any>(
      `${this.environment.AppGoalTenure}/AddGoalTenureType`,
      goalTenureType
    );
  };
  updateGoalTenureType = (goalTenureType: any) => {
    return this.http.put(
      `${this.environment.AppGoalTenure}/update`,
      goalTenureType
    );
  };
  activateGoalTenureType = (goalTenureType: any) => {
    return this.http.put(
      `${this.environment.AppGoalTenure}/activate`,
      goalTenureType
    );
  };
  getGoalTenureTypeByGoalTenureTypeId = (goalTenureTypeId: any) => {
    return this.http.get<any>(
      `${this.environment.AppGoalTenure}/get?goalTenureTypeId=${goalTenureTypeId}`
    );
  };
  getGoalTenureTypeList = (params: any) => {
    return this.http.get<any>(`${this.environment.AppGoalTenure}/getlist`, {
      params,
    });
  };
  addCalenderActivities = (CalenderActivity: any) => {
    return this.http.post<any>(
      `${this.environment.AppCalenderActivities}/Add`,
      CalenderActivity
    );
  };
  updateCalenderActivities = (CalenderActivity: any) => {
    return this.http.put(
      `${this.environment.AppCalenderActivities}/Update`,
      CalenderActivity
    );
  };
  getAllCalenderActivities = (params: any) => {
    return this.http.get<any>(
      `${this.environment.AppCalenderActivities}/getList`,
      {
        params,
      }
    );
  };
  addEventTypes = (EventType: any) => {
    return this.http.post<any>(
      `${this.environment.AppEventTypes}/Add`,
      EventType
    );
  };
  updateEventTypes = (EventType: any) => {
    return this.http.put(`${this.environment.AppEventTypes}/Update`, EventType);
  };
  getAllEventTypes = (params: any) => {
    return this.http.get<any>(`${this.environment.AppEventTypes}/getList`, {
      params,
    });
  };
  public getCalendarView = (params: any) => {
    return this.http.get<any>(
      `${this.environment.AppCalender}/getCalendarView`,
      {
        params,
      }
    );
  };
  public getGoalTypeList = (params: any) => {
    return this.http.get<any>(`${this.environment.AppGoalType}/getList`, {
      params,
    });
  };
  addSameStoreRow = (SameStoreRow: any) => {
    return this.http.post<any>(
      `${this.environment.AppSameStoreRow}/add`,
      SameStoreRow
    );
  };
  updateSameStoreRow = (SameStoreRow: any) => {
    return this.http.put(
      `${this.environment.AppSameStoreRow}/update`,
      SameStoreRow
    );
  };
  activateSameStoreRow = (SameStoreRow: any) => {
    return this.http.put(
      `${this.environment.AppSameStoreRow}/activate`,
      SameStoreRow
    );
  };
  getSameStoreRowBySameStoreRowId = (SameStoreRowId: any) => {
    return this.http.get<any>(
      `${this.environment.AppSameStoreRow}/get?SameStoreRowId=${SameStoreRowId}`
    );
  };
  getSameStoreRowList = (params: any) => {
    return this.http.get<any>(`${this.environment.AppSameStoreRow}/getlist`, {
      params,
    });
  };
  /* Source Mix Form CRUD Model */

  addSameStoreHeader = (SameStoreHeader: any) => {
    return this.http.post<any>(
      `${this.environment.AppSameStoreHeader}/AddSameStoreHeader`,
      SameStoreHeader
    );
  };
  updateSameStoreHeader = (SameStoreHeader: any) => {
    return this.http.put(
      `${this.environment.AppSameStoreHeader}/update`,
      SameStoreHeader
    );
  };
  activateSameStoreHeader = (SameStoreHeader: any) => {
    return this.http.put(
      `${this.environment.AppSameStoreHeader}/activate`,
      SameStoreHeader
    );
  };
  getSameStoreHeaderBySameStoreHeaderId = (SameStoreHeaderId: any) => {
    return this.http.get<any>(
      `${this.environment.AppSameStoreHeader}/get?SameStoreHeaderId=${SameStoreHeaderId}`
    );
  };
  getSameStoreHeaderList = (params: any) => {
    return this.http.get<any>(
      `${this.environment.AppSameStoreHeader}/getlist`,
      {
        params,
      }
    );
  };
  /* Source Mix Form CRUD Model */

  addSameStoreForm = (SameStoreForm: any) => {
    return this.http.post<any>(
      `${this.environment.AppSameStoreForm}/add`,
      SameStoreForm
    );
  };
  updateSameStoreForm = (SameStoreForm: any) => {
    return this.http.put(
      `${this.environment.AppSameStoreForm}/update`,
      SameStoreForm
    );
  };
  getSameStoreFormBySameStoreFormId = (SameStoreFormId: any) => {
    return this.http.get<any>(
      `${this.environment.AppSameStoreForm}/get?SameStoreFormId=${SameStoreFormId}`
    );
  };
  getSameStoreFormList = (params: any) => {
    return this.http.get<any>(`${this.environment.AppSameStoreForm}/getlist`, {
      params,
    });
  };
  likeDislikeAdd = (model: any) => {
    return this.http.post<any>(
      `${this.environment.AppActionItems}/likeDislikeAdd`,
      model
    );
  };
  favouriteAdd = (model: any) => {
    return this.http.post<any>(
      `${this.environment.AppActionItems}/favouriteAdd`,
      model
    );
  };
  favouriteUpdate = (model: any) => {
    return this.http.put<any>(
      `${this.environment.AppActionItems}/favouriteUpdate`,
      model
    );
  };
  favouriteActivate = (model: any) => {
    return this.http.put<any>(
      `${this.environment.AppActionItems}/favouriteActivate`,
      model
    );
  };
  favouriteGetlist = (params: any) => {
    return this.http.get<any>(
      `${this.environment.AppActionItems}/favouriteGetlist`,
      { params }
    );
  };
  addChannelSourceWiseRow = (ChannelSourceWiseRow: any) => {
    return this.http.post<any>(
      `${this.environment.AppChannelSourceWise}/ChannelSourceWiseAdd`,
      ChannelSourceWiseRow
    );
  };
  updateChannelSourceWiseRow = (ChannelSourceWiseRow: any) => {
    return this.http.put(
      `${this.environment.AppChannelSourceWise}/update`,
      ChannelSourceWiseRow
    );
  };
  activateChannelSourceWiseRow = (ChannelSourceWiseRow: any) => {
    return this.http.put(
      `${this.environment.AppChannelSourceWise}/activate`,
      ChannelSourceWiseRow
    );
  };
  getChannelSourceWiseRowByChannelSourceWiseRowId = (
    ChannelSourceWiseRowId: any
  ) => {
    return this.http.get<any>(
      `${this.environment.AppChannelSourceWise}/get?ChannelSourceWiseRowId=${ChannelSourceWiseRowId}`
    );
  };
  getChannelSourceWiseRowList = (params: any) => {
    return this.http.get<any>(
      `${this.environment.AppChannelSourceWise}/ChannelSourceWiseGetlist`,
      { params }
    );
  };
  /* Source Mix Form CRUD Model */

  addChannelSourceWiseHeader = (ChannelSourceWiseHeader: any) => {
    return this.http.post<any>(
      `${this.environment.AppChannelSourceWise}/ChannelSourceWiseHeaderAdd`,
      ChannelSourceWiseHeader
    );
  };
  updateChannelSourceWiseHeader = (ChannelSourceWiseHeader: any) => {
    return this.http.put(
      `${this.environment.AppChannelSourceWise}/update`,
      ChannelSourceWiseHeader
    );
  };
  activateChannelSourceWiseHeader = (ChannelSourceWiseHeader: any) => {
    return this.http.put(
      `${this.environment.AppChannelSourceWise}/ChannelSourceWiseHeaderActivate`,
      ChannelSourceWiseHeader
    );
  };
  getChannelSourceWiseHeaderByChannelSourceWiseHeaderId = (
    ChannelSourceWiseHeaderId: any
  ) => {
    return this.http.get<any>(
      `${this.environment.AppChannelSourceWise}/get?ChannelSourceWiseHeaderId=${ChannelSourceWiseHeaderId}`
    );
  };
  getChannelSourceWiseHeaderList = (params: any) => {
    return this.http.get<any>(
      `${this.environment.AppChannelSourceWise}/ChannelSourceWiseHeaderGetlist`,
      { params }
    );
  };
  /* Category CRUD Model */

  addMenu = (Menu: any) => {
    return this.http.post<any>(`${this.environment.AppMenu}/add`, Menu);
  };
  updateMenu = (Menu: any) => {
    return this.http.put(`${this.environment.AppMenu}/update`, Menu);
  };
  activateMenu = (Menu: any) => {
    return this.http.put(`${this.environment.AppMenu}/activate`, Menu);
  };
  activateMenuTree = (Menu: any) => {
    return this.http.put<any>(`${this.environment.AccountHierarchy}/ActivateAccountHierarchyData`, Menu);
  };

  activateCalendarHierarchyDataTree = (Menu: any) => {
    return this.http.put<any>(`${this.environment.CalendarHierarchy}/ActivateCalendarHierarchyData`, Menu);
  };

  DeleteAccountHierarchy = (DAH: any) => {
    return this.http.put<any>(`${this.environment.AccountHierarchy}/ActivateAccountHierarchy`, DAH);
  };
  DeleteCalendarHierarchy = (DAH: any) => {
    return this.http.put<any>(`${this.environment.CalendarHierarchy}/ActivateCalendarHierarchy`, DAH);
  };
  updateMenuOrder = (Menu: any) => {
    return this.http.put(`${this.environment.AppMenu}/UpdateOrder`, Menu);
  };
  searchMenu = (searchText: string) => {
    return this.http.get<any>(
      `${this.environment.AppMenu}/search?search=${searchText}`
    );
  };
  getMenu = (MenuId: string) => {
    return this.http.get<any>(
      `${this.environment.AppMenu}/get?MenuId=${MenuId}`
    );
  };
  getAllMenus = (params: any) => {
    return this.http.get<any>(`${this.environment.AppMenu}/getall`, { params });
  };
  getMenuList = (params: any) => {
    return this.http.get<any>(`${this.environment.AppMenu}/getlist`, {
      params,
    });
  };
  ScreenGetlist = (params: any) => {
    return this.http.get<any>(`${this.environment.AppMenu}/ScreenGetlist`, {
      params,
    });
  };
  getScreens = (query: any) => {
    return this.http.get<any>(
      `${this.environment.AppMenu}/GetScreens?${query}`
    );
  };
  addScreen = (Screen: any) => {
    return this.http.post<any>(`${this.environment.AppMenu}/addScreen`, Screen);
  };
  updateScreen = (Screen: any) => {
    return this.http.put(`${this.environment.AppMenu}/updateScreen`, Screen);
  };
  GetAllActivity = (params: any) => {
    return this.http.get<any>(
      `${this.environment.AppActionItems}/AllActivity`,
      {
        params,
      }
    );
  };
  GetMyActivity = (params: any) => {
    return this.http.get<any>(`${this.environment.AppActionItems}/MyActivity`, {
      params,
    });
  };
  // Algo Announcement

  public AnnouncementAdd = (body: any) => {
    return this.http.post<number>(
      `${this.environment.AppAnnouncement}/add`,
      body
    );
  };
  public AnnouncementUpdate = (body: any) => {
    return this.http.put<boolean>(
      `${this.environment.AppAnnouncement}/update`,
      body
    );
  };
  public AnnouncementActivate = (body: any) => {
    return this.http.put<boolean>(
      `${this.environment.AppAnnouncement}/activate`,
      body
    );
  };
  AnnouncementGetAll(params: any): Observable<any> {
    return this.http.get<any>(
      `${this.environment.AppAnnouncement}/getAllAnnouncements`,
      { params }
    );
  }
  updateAnnouncementOrderNumber(body: any): Observable<any> {
    return this.http.put<any>(
      `${this.environment.AppAnnouncement}/updateAnnouncementOrderNumber`,
      body
    );
  }
  // Algo User Interface
  public AddUserInterface = (body: any) => {
    return this.http.post<any>(
      `${this.environment.AppActionItems}/AddUserInterface`,
      body
    );
  };
  GetUserInterfaceActivityAll = (params: any) => {
    return this.http.get<any>(
      `${this.environment.AppActionItems}/GetUserInterfaceActivityAll`,
      { params }
    );
  };
  // Algo Announcement

  public NoteAdd = (body: any) => {
    return this.http.post<number>(`${this.environment.AppNote}/add`, body);
  };
  public NoteUpdate = (body: any) => {
    return this.http.put<boolean>(`${this.environment.AppNote}/update`, body);
  };
  public NoteActivate = (body: any) => {
    return this.http.put<boolean>(`${this.environment.AppNote}/activate`, body);
  };
  NoteGetList(params: any): Observable<any> {
    return this.http.get<any>(`${this.environment.AppNote}/GetList`, {
      params,
    });
  }
  NoteGet(params: any): Observable<any> {
    return this.http.get<any>(`${this.environment.AppNote}/Get`, { params });
  }
  GetBudgetList = (params: any) => {
    return this.http.get<any>(`${this.environment.AppAPBudgetType}/GetList`, {
      params,
    });
  };
  // Algo Promotion

  public PromotionAdd = (body: any) => {
    return this.http.post<number>(`${this.environment.AppPromotion}/add`, body);
  };
  public PromotionUpdate = (body: any) => {
    return this.http.put<boolean>(
      `${this.environment.AppPromotion}/update`,
      body
    );
  };
  public PromotionActivate = (body: any) => {
    return this.http.put<boolean>(
      `${this.environment.AppPromotion}/activate`,
      body
    );
  };
  PromotionGetAll(params: any): Observable<any> {
    return this.http.get<any>(`${this.environment.AppPromotion}/getList`, {
      params,
    });
  }
  PromotionGet(params: any): Observable<any> {
    return this.http.get<any>(`${this.environment.AppPromotion}/get`, {
      params,
    });
  }
  // Algo SKU

  public SKUAdd = (body: any) => {
    return this.http.post<number>(`${this.environment.AppSKU}/add`, body);
  };
  public SKUUpdate = (body: any) => {
    return this.http.put<boolean>(`${this.environment.AppSKU}/update`, body);
  };
  public SKUActivate = (body: any) => {
    return this.http.put<boolean>(`${this.environment.AppSKU}/activate`, body);
  };
  SKUGetAll(params: any): Observable<any> {
    return this.http.get<any>(`${this.environment.AppSKU}/getList`, { params });
  }
  SKUGet(params: any): Observable<any> {
    return this.http.get<any>(`${this.environment.AppSKU}/get`, { params });
  }
  // Algo SKU

  public SKUPromotionAdd = (body: any) => {
    return this.http.post<number>(
      `${this.environment.AppSKUPromotion}/add`,
      body
    );
  };
  public SKUPromotionUpdate = (body: any) => {
    return this.http.put<boolean>(
      `${this.environment.AppSKUPromotion}/update`,
      body
    );
  };
  public SKUPromotionActivate = (body: any) => {
    return this.http.put<boolean>(
      `${this.environment.AppSKUPromotion}/activate`,
      body
    );
  };
  SKUPromotionGetAll(params: any): Observable<any> {
    return this.http.get<any>(`${this.environment.AppSKUPromotion}/getList`, {
      params,
    });
  }
  SKUPromotionGet(params: any): Observable<any> {
    return this.http.get<any>(`${this.environment.AppSKUPromotion}/get`, {
      params,
    });
  }
  // Algo Decay Curve

  public DecayCurveAdd = (body: any) => {
    return this.http.post<number>(
      `${this.environment.AppDecayCurve}/add`,
      body
    );
  };
  public DecayCurveUpdate = (body: any) => {
    return this.http.put<boolean>(
      `${this.environment.AppDecayCurve}/update`,
      body
    );
  };
  public DecayCurveActivate = (body: any) => {
    return this.http.put<boolean>(
      `${this.environment.AppDecayCurve}/activate`,
      body
    );
  };
  DecayCurveGetAll(params: any): Observable<any> {
    return this.http.get<any>(`${this.environment.AppDecayCurve}/getList`, {
      params,
    });
  }
  DecayCurveGet(params: any): Observable<any> {
    return this.http.get<any>(`${this.environment.AppDecayCurve}/get`, {
      params,
    });
  }
  // Algo Item Master

  public ItemMasterAdd = (body: any) => {
    return this.http.post<number>(
      `${this.environment.AppItemMaster}/add`,
      body
    );
  };
  public ItemMasterUpdate = (body: any) => {
    return this.http.put<boolean>(
      `${this.environment.AppItemMaster}/update`,
      body
    );
  };
  public ItemMasterActivate = (body: any) => {
    return this.http.put<boolean>(
      `${this.environment.AppItemMaster}/activate`,
      body
    );
  };
  ItemMasterGetAll(params: any): Observable<any> {
    return this.http.get<any>(`${this.environment.AppItemMaster}/getList`, {
      params,
    });
  }
  ItemMasterGet(params: any): Observable<any> {
    return this.http.get<any>(`${this.environment.AppItemMaster}/get`, {
      params,
    });
  }
  public UploadDoc = (body: any) => {
    return this.http.post<any>(`${this.environment.UploadDoc}`, body);
  };
  public findAnomoly = (body: any) => {
    return this.http.post<any>(`${this.environment.Anomoly}`, body);
  };
  oldAnomolyFiles(params: any): Observable<any> {
    return this.http.get<any>(`${this.environment.AnomolyFiles}`, { params });
  }
  syncPoweBIReports(): Observable<any> {
    return this.http.get<any>(`${this.environment.SyncPowerBIReports}`);
  }

  // Algo App Insight

  public ApplicationInsightsAdd = (body: any) => {
    return this.http.post<number>(
      `${this.environment.ApplicationInsights}/add`,
      body
    );
  };
  public ApplicationInsightsUpdate = (body: any) => {
    return this.http.put<boolean>(
      `${this.environment.ApplicationInsights}/update`,
      body
    );
  };
  public ApplicationInsightsActivate = (body: any) => {
    return this.http.put<boolean>(
      `${this.environment.ApplicationInsights}/activate`,
      body
    );
  };
  ApplicationInsightsGetAll(params: any): Observable<any> {
    return this.http.get<any>(
      `${this.environment.ApplicationInsights}/getList`,
      {
        params,
      }
    );
  }
  ApplicationInsightsGet(params: any): Observable<any> {
    return this.http.get<any>(`${this.environment.ApplicationInsights}/get`, {
      params,
    });
  }
  ApplicationInsightsPublish(params: any): Observable<any> {
    return this.http.put<any>(
      `${this.environment.ApplicationInsights}/publish`,
      params
    );
  }
  ApplicationInsightDelete(params: any): Observable<any> {
    return this.http.put<any>(
      `${this.environment.ApplicationInsights}/delete`,
      params
    );
  }
  UploadFiles(model: any) {
    return this.http.post<number>(
      `${this.environment.AppDocument}/UploadFiles`,
      model
    );
  }
  Import(model: any) {
    var formData = new FormData();
    formData.append('file', model.file);
    formData.append('userId', model.userId);
    formData.append('versionTypeId', model.versionTypeId);
    formData.append('fbTemplateId', model.fbTemplateId);
    formData.append('isActiveAccount', model.isActiveAccount);
    formData.append('userFBForecastId', model.userFBForecastId);
    formData.append('guid', model.guid);
    formData.append('fromTemplateId', model.fromTemplateId);
    formData.append('selectedCurrencyId', model.selectedCurrencyId);
    return this.http.post<Array<any>>(
      `${this.environment.AppFBForcast}/Import`,
      formData
    );
  }
  ImportVerticalLayout(model: any) {
    var formData = new FormData();
    formData.append('file', model.file);
    formData.append('userId', model.userId);
    formData.append('versionTypeId', model.versionTypeId);
    formData.append('fbTemplateId', model.fbTemplateId);
    formData.append('isActiveAccount', model.isActiveAccount);
    formData.append('userFBForecastId', model.userFBForecastId);
    formData.append('guid', model.guid);
    formData.append('isPivotImport', model.isPivotImport);
    formData.append('fromTemplateId', model.fromTemplateId);
    formData.append('selectedCurrencyId', model.selectedCurrencyId);
    return this.http.post<Array<any>>(
      `${this.environment.AppFBForcast}/ImportVerticalLayout`,
      formData
    );
  }
  ImportNew(model: any): Observable<any> {
    var requestPayload = new FormData();
    requestPayload.append('file', model.file);
    requestPayload.append('userId', model.userId);
    requestPayload.append('versionTypeId', model.versionTypeId);
    requestPayload.append('fbTemplateId', model.fbTemplateId);
    requestPayload.append('isActiveAccount', model.isActiveAccount);
    requestPayload.append('userFBForecastId', model.userFBForecastId);
    requestPayload.append('guid', model.guid);
    requestPayload.append('isPivotImport', model.isPivotImport);
    requestPayload.append('tableName', model.tableName);
    requestPayload.append('fromTemplateId', model.fromTemplateId);
    requestPayload.append('selectedCurrencyId', model.selectedCurrencyId);
    return this.http.post<any>(`${this.environment.AppFBForcast}/ImportNew`, requestPayload);
  }
  LookupGetByCode(params: any): Observable<any> {
    return this.http.get<any>(
      `${this.environment.AppCommonCode}/getList?code=${params}`
    );
  }
  importExcel = (fileName: string) => {
    return this.http.get(`assets/${fileName}.xlsx`, { responseType: 'blob' });
  };
  // Algo App Insight

  public SuggestAdminAdd = (body: any) => {
    return this.http.post<number>(
      `${this.environment.AppSuggestAdmin}/add`,
      body
    );
  };
  public SuggestAdminUpdate = (body: any) => {
    return this.http.put<boolean>(
      `${this.environment.AppSuggestAdmin}/update`,
      body
    );
  };
  public SuggestAdminUpdateStatus = (body: any) => {
    return this.http.put<boolean>(
      `${this.environment.AppSuggestAdmin}/updatestatus`,
      body
    );
  };
  public SuggestAdminActivate = (body: any) => {
    return this.http.put<boolean>(
      `${this.environment.AppSuggestAdmin}/activate`,
      body
    );
  };
  SuggestAdminGetAll(params: any): Observable<any> {
    return this.http.get<any>(`${this.environment.AppSuggestAdmin}/getList`, {
      params,
    });
  }
  SuggestAdminGet(params: any): Observable<any> {
    return this.http.get<any>(`${this.environment.AppSuggestAdmin}/get`, {
      params,
    });
  }
  SuggestionStatusGetList(params: any): Observable<any> {
    return this.http.get<any>(
      `${this.environment.AppSuggestAdmin}/SuggestionStatusGetList`,
      { params }
    );
  }

  public CurrencyAdd = (body: any) => {
    return this.http.post<number>(`${this.environment.AppCurrency}/add`, body);
  };
  public CurrencyUpdate = (body: any) => {
    return this.http.put<boolean>(
      `${this.environment.AppCurrency}/update`,
      body
    );
  };
  public CurrencyActivate = (body: any) => {
    return this.http.put<boolean>(
      `${this.environment.AppCurrency}/activate`,
      body
    );
  };
  CurrencyGetAll(params: any): Observable<any> {
    return this.http.get<any>(`${this.environment.AppCurrency}/getList`, {
      params,
    });
  }
  public CurrencyRateAdd = (body: any) => {
    return this.http.post<number>(
      `${this.environment.AppCurrencyRate}/add`,
      body
    );
  };
  CurrencyRateGetAll(params: any): Observable<any> {
    return this.http.get<any>(`${this.environment.AppCurrencyRate}/getList`, {
      params,
    });
  }
  CustomerGetList(params: any): Observable<any> {
    return this.http.get<any>(
      `${this.environment.AppBuyerSetting}/CustomerGetList`,
      { params }
    );
  }
  ChannelGetList(params: any): Observable<any> {
    return this.http.get<any>(
      `${this.environment.AppBuyerSetting}/ChannelGetList`,
      {
        params,
      }
    );
  }
  CountryGetList(params: any): Observable<any> {
    return this.http.get<any>(
      `${this.environment.AppAccountSettingMapping}/CountryGetList`,
      { params }
    );
  }
  BuyerSettingGet(params: any): Observable<any> {
    return this.http.get<any>(`${this.environment.AppBuyerSetting}/Get`, {
      params,
    });
  }
  BuyerSettingAdd(model: any): Observable<any> {
    return this.http.post<any>(
      `${this.environment.AppBuyerSetting}/Add`,
      model
    );
  }
  BuyerSettingUpdate(model: any): Observable<any> {
    return this.http.put<any>(
      `${this.environment.AppBuyerSetting}/Update`,
      model
    );
  }
  public FinanceAdd = (body: any) => {
    return this.http.post<number>(
      `${this.environment.AppFinanceSetting}/add`,
      body
    );
  };
  public FinanceUpdate = (body: any) => {
    return this.http.put<boolean>(
      `${this.environment.AppFinanceSetting}/update`,
      body
    );
  };
  public FinanceActivate = (body: any) => {
    return this.http.put<boolean>(
      `${this.environment.AppFinanceSetting}/activate`,
      body
    );
  };
  FinanceGetAll(params: any): Observable<any> {
    return this.http.get<any>(`${this.environment.AppFinanceSetting}/getList`, {
      params,
    });
  }
  TeamFinanceGetList(params: any): Observable<any> {
    return this.http.get<any>(
      `${this.environment.AppFinanceSetting}/getFinancialSettingTeam`,
      { params }
    );
  }
  AddFinancialSettingTeam(model: any): Observable<any> {
    return this.http.post<any>(
      `${this.environment.AppFinanceSetting}/addFinancialSettingTeam`,
      model
    );
  }
  TeamCurrencyGetList(params: any): Observable<any> {
    return this.http.get<any>(
      `${this.environment.AppCurrency}/getCurrencySettingTeam`,
      { params }
    );
  }
  AddCurrencySettingTeam(model: any): Observable<any> {
    return this.http.post<any>(
      `${this.environment.AppCurrency}/addCurrencySettingTeam`,
      model
    );
  }
  GetItemList(params: any): Observable<any> {
    return this.http.get<any>(
      `${this.environment.AppProductSetting}/getItemList`,
      {
        params,
      }
    );
  }
  AddProductSetting(model: any): Observable<any> {
    return this.http.post<any>(
      `${this.environment.AppProductSetting}/add`,
      model
    );
  }
  UpdateProductSetting(model: any): Observable<any> {
    return this.http.put<any>(
      `${this.environment.AppProductSetting}/update`,
      model
    );
  }
  GetProductSetting(params: any): Observable<any> {
    return this.http.get<any>(`${this.environment.AppProductSetting}/get`, {
      params,
    });
  }
  measuresGetList(params: any): Observable<Measure[]> {
    return this.http.get<Measure[]>(
      `${this.environment.AppFBForcast}/measuresGetList`,
      { params }
    );
  }
  UpdateMeasureValues(model: any): Observable<any> {
    return this.http.put<any>(
      `${this.environment.AppFBForcast}/UpdateMeasureValues`,
      model
    );
  }
  MeasuresSortUpdate(model: any): Observable<any> {
    return this.http.put<any>(
      `${this.environment.AppFBForcast}/MeasuresSortUpdate`,
      model
    );
  }
  AddPlannerMeasures(model: any) {
    return this.http.post<boolean>(
      `${this.environment.AppFBForcast}/AddPlannerMeasures`,
      model
    );
  }
  channelGetList(params: any): Observable<FbChannel[]> {
    return this.http.get<FbChannel[]>(
      `${this.environment.AppFBForcast}/channelGetList`,
      { params }
    );
  }
  calendarGetList(params: any): Observable<Calendar[]> {
    return this.http.get<Calendar[]>(
      `${this.environment.AppFBForcast}/calendarGetList`,
      { params }
    );
  }
  versionTypeGetList(params: any): Observable<Version[]> {
    return this.http.get<Version[]>(
      `${this.environment.AppFBForcast}/versionTypeGetList`,
      { params }
    );
  }
  userFBForecastGetList(params: any): Observable<UserFbForecast[]> {
    return this.http.get<UserFbForecast[]>(
      `${this.environment.AppFBForcast}/userFBForecastGetList`,
      { params }
    );
  }
  userFBForecastDeleteByVersionID(fbForecast: any) {
    return this.http.post<boolean>(
      `${this.environment.AppFBForcast}/UserFBForecastDeleteByVersionID`,
      fbForecast
    );
  }
  GetFbForecast(params: any): Observable<FbForecast> {
    return this.http.post<FbForecast>(
      `${this.environment.AppFBForcast}/fbForecastGet`,
      params
    );
  }
  GetUserSession(params: any): Observable<FbForecast> {
    return this.http.post<FbForecast>(
      `${this.environment.AppFBForcast}/fBForecastGetUserSession`,
      params
    );
  }
  AddFbForecast(FbForecast: FbForecast): Observable<FbForecast> {
    return this.http.post<FbForecast>(
      `${this.environment.AppFBForcast}/fbForecastAdd`,
      FbForecast
    );
  }
  fbForecastAddPerformance(FbForecast: FbForecast): Observable<FbForecast> {
    return this.http.post<FbForecast>(
      `${this.environment.AppFBForcast}/fbForecastAddPerformance`,
      FbForecast
    );
  }
  FBForecastSelectedUpdateByDropDownType(model: any): Observable<FbForecast> {
    return this.http.post<FbForecast>(
      `${this.environment.AppFBForcast}/FBForecastSelectedUpdateByDropDownType`,
      model
    );
  }
  FBForecastCommit(FbForecast: any): Observable<boolean> {
    return this.http.post<boolean>(
      `${this.environment.AppFBForcast}/FBForecastCommit`,
      FbForecast
    );
  }
  SpreadingForecastAddCommitMeasures(FbForecast: any): Observable<boolean> {
    return this.http.post<boolean>(
      `${this.environment.AppFBSpreading}/SpreadingForecastAddCommitMeasures`,
      FbForecast
    );
  }
  userFBForecastAdd(FbForecast: any): Observable<number> {
    return this.http.post<number>(
      `${this.environment.AppFBForcast}/userFBForecastAdd`,
      FbForecast
    );
  }
  userFBForecastUpdate(FbForecast: any): Observable<number> {
    return this.http.put<number>(
      `${this.environment.AppFBForcast}/userFBForecastUpdate`,
      FbForecast
    );
  }
  userFBForecastRefreshMeasure(params: any) {
    return this.http.post<any>(
      `${this.environment.AppFBForcast}/fbForecastMasterRefreshGet`,
      params
    );
  }
  DefaultAddRefresh(params: any) {
    return this.http.post<any>(
      `${this.environment.AppFBSpreading}/DefaultAddRefresh`,
      params
    );
  }
  fbForecastGetPerformance(params: any) {
    return this.http.post<any>(
      `${this.environment.AppFBForcast}/fbForecastGetPerformance`,
      params
    );
  }
  fbForecastGetPerformanceRI(params: any) {
    return this.http.post<any>(
      `${this.environment.AppFBForcast}/fbForecastGetPerformanceRI`,
      params
    );
  }
  GetWeekByDate(params: any) {
    return this.http.get<any>(`${this.environment.AppFBForcast}/GetWeekByDate`, { params });
  }

  // Item Actions

  public UploadItemManagerCSVAsTable = (body: any) => {
    var formData = new FormData();
    formData.append('file', body.file);
    formData.append('tablename', body.tableName);
    return this.http.post<number>(
      `${this.environment.AppItemManager}/UploadItemManagerCSVAsTable`,
      formData
    );
  };
  public UploadCalendarHierarchyCSVAsTable = (body: any) => {
    var formData = new FormData();
    formData.append('file', body.file);
    formData.append('tablename', body.tableName);
    return this.http.post<number>(
      `${this.environment.CalendarHierarchy}/UploadCalendarHierarchyCSVAsTable`,
      formData
    );
  };
  public UploadAccountHierarchyCSVAsTable = (body: any) => {
    var formData = new FormData();
    formData.append('file', body.file);
    formData.append('tablename', body.tableName);
    return this.http.post<number>(
      `${this.environment.AccountHierarchy}/UploadAccountHierarchyCSVAsTable`,
      formData
    );
  };
  public ItemManagerAdd = (body: any) => {
    return this.http.post<number>(
      `${this.environment.AppItemManager}/ItemManagerAdd`,
      body
    );
  };
  public ItemManagerUpdate = (body: any) => {
    return this.http.put<boolean>(
      `${this.environment.AppItemManager}/ItemManagerUpdate`,
      body
    );
  };
  public ItemManagerActivate = (body: any) => {
    return this.http.put<boolean>(
      `${this.environment.AppItemManager}/ItemManagerActivate`,
      body
    );
  };
  ItemManagerGet(params: any): Observable<any> {
    return this.http.get<any>(
      `${this.environment.AppItemManager}/ItemManagerGet?ItemManagerId=${params}`
    );
  }
  DistiMasterGetList(params: any): Observable<any> {
    return this.http.post<any>(
      `${this.environment.AppItemManager}/DistiManagerGetList`, params);
  }
  ItemManagerGetAll(url: any): Observable<any> {
    return this.http.get<any>(
      `${this.environment.AppItemManager}/ItemManagerGetAll?${url}`
    );
  }
  ItemMasterGetList(param: any): Observable<any> {
    return this.http.post<any>(
      `${this.environment.AppItemManager}/ItemManagerGetList`, param
    );
  }
  AccountMasterGetList(param: any): Observable<any> {
    return this.http.post<any>(
      `${this.environment.AppItemManager}/ItemManagerGetListbyAccount`, param
    );
  }
  ItemManagerExport(params: any): Observable<any> {
    return this.http.get<any>(`${this.environment.AppItemManager}/ItemManagerExport`, { params });
  }
  AccountManagerExport(params: any): Observable<any> {
    return this.http.get<any>(`${this.environment.AppItemManager}/AccountManagerExport`, { params });
  }
  ItemManagerGetAllMS(url: any): Observable<any> {
    return this.http.get<any>(
      `${this.environment.AppItemManager}/ItemManagerGetAllMS?${url}`
    );
  }
  OrderListGetAll(params: any): Observable<any> {
    return this.http.get<any>(
      `${this.environment.OrderList}/MSOrderListGetAll`,
      { params }
    );
  }
  public ItemAccountAdd = (body: any) => {
    return this.http.post<number>(
      `${this.environment.AppItemManager}/ItemAccountAdd`,
      body
    );
  };
  public ItemAccountUpdate = (body: any) => {
    return this.http.put<boolean>(
      `${this.environment.AppItemManager}/ItemAccountUpdate`,
      body
    );
  };
  public ItemAccountActivate = (body: any) => {
    return this.http.put<boolean>(
      `${this.environment.AppItemManager}/ItemAccountActivate`,
      body
    );
  };
  ItemAccountGet(params: any): Observable<any> {
    return this.http.get<any>(
      `${this.environment.AppItemManager}/ItemAccountGet?ItemAccountId=${params}`
    );
  }
  ItemAccountGetAll(url: any): Observable<any> {
    return this.http.get<any>(
      `${this.environment.AppItemManager}/ItemAccountGetAll?${url}`
    );
  }
  ItemAccountGetAllMS(url: any): Observable<any> {
    return this.http.get<any>(
      `${this.environment.AppItemManager}/ItemAccountGetAllMS?${url}`
    );
  }
  ItemAccountGetList(params: any): Observable<any> {
    return this.http.get<any>(
      `${this.environment.AppItemManager}/ItemAccountGetList`,
      { params }
    );
  }
  public ItemAccountSettingAdd = (body: any) => {
    return this.http.post<any>(
      `${this.environment.AppItemManager}/ItemAccountSettingAdd`,
      body
    );
  };
  public ItemAccountSettingDelete = (body: any) => {
    return this.http.post<any>(
      `${this.environment.AppItemManager}/ItemAccountSettingDeleteByIds`,
      body
    );
  };
  public AccountSettingUpdate = (body: any) => {
    return this.http.post<any>(
      `${this.environment.AppItemManager}/AccountSettingUpdate`,
      body
    );
  };
  public AccountSettingListUpdate = (body: any) => {
    return this.http.post<any>(
      `${this.environment.AppItemManager}/AccountSettingListUpdate`,
      body
    );
  };
  public GetNIPCalculation = (body: any) => {
    return this.http.post<any>(
      `${this.environment.AppItemManager}/GetNIPCalculation`,
      body
    );
  };
  ItemAccountSettingGet(params: any): Observable<any> {
    return this.http.get<any>(
      `${this.environment.AppItemManager}/ItemAccountSettingGet`,
      { params }
    );
  }
  GetItemSettings(params: any): Observable<any> {
    return this.http.post<any>(`${this.environment.AppItemManager}/GetItemSettings`, params);
  }
  AccountsListGetByItem(model: any): Observable<any> {
    return this.http.get<any>(
      `${this.environment.AppItemManager}/AccountsListGetByItem?itemManagerId=${model}`
    );
  }
  GetItemSettingsByDisti(params: any): Observable<any> {
    return this.http.get<any>(
      `${this.environment.AppItemManager}/GetItemSettingsByDisti`,
      {
        params,
      }
    );
  }
  FbForecastSpreadingAddBulk(params: any): Observable<any> {
    return this.http.post(
      `${this.environment.AppFBSpreading}/spreadingAddBulk`,
      params
    );
  }
  GetLookupByCode(code: any): Observable<any> {
    return this.http.get<any>(
      `${this.environment.AppCommonCode}/GetLookupByCode/${code}`
    );
  }
  GetLookupList(code: any): Observable<any> {
    return this.http.get<any>(
      `${this.environment.AppCommonCode}/GetList?Code=${code}`
    );
  }
  GetRegionList(): Observable<any> {
    return this.http.get<any>(
      `${this.environment.AppItemManager}/RegionGetList`
    );
  }

  public DocumentAdd = (body: any) => {
    return this.http.post<any>(
      `${this.environment.AppCommonCode}/DocumentAdd`,
      body
    );
  };
  TeamScreenGroupGetList(params: any): Observable<any> {
    return this.http.get<any>(
      `${this.environment.AppTeamScreenGroup}/GetList`,
      {
        params,
      }
    );
  }
  TeamScreenGroupAdd(body: any): Observable<any> {
    return this.http.post<any>(
      `${this.environment.AppTeamScreenGroup}/Add`,
      body
    );
  }
  // Item forecast

  itemMeasuresGetList(params: any): Observable<Measure[]> {
    return this.http.get<Measure[]>(
      `${this.environment.AppItemForcast}/measuresGetList`,
      { params }
    );
  }
  itemChannelGetList(params: any): Observable<FbChannel[]> {
    return this.http.get<FbChannel[]>(
      `${this.environment.AppItemForcast}/channelGetList`,
      { params }
    );
  }
  itemCalendarGetList(params: any): Observable<Calendar[]> {
    return this.http.get<Calendar[]>(
      `${this.environment.AppItemForcast}/calendarGetList`,
      { params }
    );
  }
  itemVersionTypeGetList(params: any): Observable<Version[]> {
    return this.http.get<Version[]>(
      `${this.environment.AppItemForcast}/versionTypeGetList`,
      { params }
    );
  }
  userItemForecastGetList(params: any): Observable<UserFbForecast[]> {
    return this.http.get<UserFbForecast[]>(
      `${this.environment.AppItemForcast}/userItemForecastGetList`,
      { params }
    );
  }
  userItemForecastDeleteByVersionID(fbForecast: any) {
    return this.http.post<boolean>(
      `${this.environment.AppItemForcast}/UserItemForecastDeleteByVersionID`,
      fbForecast
    );
  }
  GetItemForecast(params: any): Observable<FbForecast> {
    return this.http.get<FbForecast>(
      `${this.environment.AppItemForcast}/ItemForecastGet`,
      { params }
    );
  }
  AddItemForecast(FbForecast: any): Observable<FbForecast> {
    return this.http.post<FbForecast>(
      `${this.environment.AppItemForcast}/ItemForecastAdd`,
      FbForecast
    );
  }
  ItemForecastCommit(FbForecast: any): Observable<boolean> {
    return this.http.post<boolean>(
      `${this.environment.AppItemForcast}/ItemForecastCommit`,
      FbForecast
    );
  }
  userItemForecastAdd(FbForecast: any): Observable<number> {
    return this.http.post<number>(
      `${this.environment.AppItemForcast}/userItemForecastAdd`,
      FbForecast
    );
  }
  userItemForecastUpdate(FbForecast: any): Observable<number> {
    return this.http.put<number>(
      `${this.environment.AppItemForcast}/userItemForecastUpdate`,
      FbForecast
    );
  }
  AccountSettingMappingGetList(params: any): Observable<any> {
    return this.http.get<any>(
      `${this.environment.AppAccountSettingMapping}/GetList`,
      { params }
    );
  }
  AccountSettingMappingGetLists(params: any): Observable<any> {
    return this.http.get<any>(
      `${this.environment.AppAccountSettingMapping}/accountHierarchyGetList`,
      { params }
    );
  }
  AccountSettingMappingAddChannel(body: any): Observable<any> {
    return this.http.post<any>(
      `${this.environment.AppAccountSettingMapping}/AddChannel`,
      body
    );
  }
  AccountSettingMappingAddContinent(body: any): Observable<any> {
    return this.http.post<any>(
      `${this.environment.AppAccountSettingMapping}/AddContinent`,
      body
    );
  }
  AccountSettingMappingAddCountry(body: any): Observable<any> {
    return this.http.post<any>(
      `${this.environment.AppAccountSettingMapping}/AddCountry`,
      body
    );
  }
  AccountSettingMappingAddDistributor(body: any): Observable<any> {
    return this.http.post<any>(
      `${this.environment.AppAccountSettingMapping}/AddDistributor`,
      body
    );
  }
  AccountSettingMappingUpdateChannel(body: any): Observable<any> {
    return this.http.put<any>(
      `${this.environment.AppAccountSettingMapping}/UpdateChannel`,
      body
    );
  }
  AccountSettingMappingUpdateContinent(body: any): Observable<any> {
    return this.http.put<any>(
      `${this.environment.AppAccountSettingMapping}/UpdateContinent`,
      body
    );
  }
  AccountSettingMappingUpdateCountry(body: any): Observable<any> {
    return this.http.put<any>(
      `${this.environment.AppAccountSettingMapping}/UpdateCountry`,
      body
    );
  }
  AccountSettingMappingUpdateDistributor(body: any): Observable<any> {
    return this.http.put<any>(
      `${this.environment.AppAccountSettingMapping}/UpdateDistributor`,
      body
    );
  }
  AccountSettingMappingActivateChannel(body: any): Observable<any> {
    return this.http.put<any>(
      `${this.environment.AppAccountSettingMapping}/ActivateChannel`,
      body
    );
  }
  AccountSettingMappingActivateContinent(body: any): Observable<any> {
    return this.http.put<any>(
      `${this.environment.AppAccountSettingMapping}/ActivateContinent`,
      body
    );
  }
  AccountSettingMappingActivateCountry(body: any): Observable<any> {
    return this.http.put<any>(
      `${this.environment.AppAccountSettingMapping}/ActivateCountry`,
      body
    );
  }
  AccountSettingMappingActivateDistributor(body: any): Observable<any> {
    return this.http.put<any>(
      `${this.environment.AppAccountSettingMapping}/ActivateDistributor`,
      body
    );
  }
  ProductSettingMappingGetList(params: any): Observable<any> {
    return this.http.get<any>(
      `${this.environment.AppProductSettingMapping}/GetList`,
      { params }
    );
  }
  ProductSettingMappingGetLists(params: any): Observable<any> {
    return this.http.get<any>(
      `${this.environment.AppProductSettingMapping}/getlistItemHierarchy`,
      { params }
    );
  }
  ProductSettingMappingAddBrand(body: any): Observable<any> {
    return this.http.post<any>(
      `${this.environment.AppProductSettingMapping}/AddBrand`,
      body
    );
  }
  ProductSettingMappingAddProductGroup(body: any): Observable<any> {
    return this.http.post<any>(
      `${this.environment.AppProductSettingMapping}/AddProductGroup`,
      body
    );
  }
  ProductSettingMappingAddProductFamily(body: any): Observable<any> {
    return this.http.post<any>(
      `${this.environment.AppProductSettingMapping}/AddProductFamily`,
      body
    );
  }
  ProductSettingMappingAddParentProduct(body: any): Observable<any> {
    return this.http.post<any>(
      `${this.environment.AppProductSettingMapping}/AddParentProduct`,
      body
    );
  }
  ProductSettingMappingUpdateBrand(body: any): Observable<any> {
    return this.http.put<any>(
      `${this.environment.AppProductSettingMapping}/UpdateBrand`,
      body
    );
  }
  ProductSettingMappingUpdateProductGroup(body: any): Observable<any> {
    return this.http.put<any>(
      `${this.environment.AppProductSettingMapping}/UpdateProductGroup`,
      body
    );
  }
  ProductSettingMappingUpdateProductFamily(body: any): Observable<any> {
    return this.http.put<any>(
      `${this.environment.AppProductSettingMapping}/UpdateProductFamily`,
      body
    );
  }
  ProductSettingMappingUpdateParentProduct(body: any): Observable<any> {
    return this.http.put<any>(
      `${this.environment.AppProductSettingMapping}/UpdateParentProduct`,
      body
    );
  }
  ProductSettingMappingActivateBrand(body: any): Observable<any> {
    return this.http.put<any>(
      `${this.environment.AppProductSettingMapping}/ActivateBrand`,
      body
    );
  }
  ProductSettingMappingActivateProductGroup(body: any): Observable<any> {
    return this.http.put<any>(
      `${this.environment.AppProductSettingMapping}/ActivateProductGroup`,
      body
    );
  }
  ProductSettingMappingActivateProductFamily(body: any): Observable<any> {
    return this.http.put<any>(
      `${this.environment.AppProductSettingMapping}/ActivateProductFamily`,
      body
    );
  }
  ProductSettingMappingActivateParentProduct(body: any): Observable<any> {
    return this.http.put<any>(
      `${this.environment.AppProductSettingMapping}/ActivateParentProduct`,
      body
    );
  }

  AccountSettingMappingChannelGetList(params: any): Observable<any> {
    return this.http.get<any>(
      `${this.environment.AppAccountSettingMapping}/ChannelsGetList`,
      { params }
    );
  }
  AccountSettingMappingContinentGetList(params: any): Observable<any> {
    return this.http.get<any>(
      `${this.environment.AppAccountSettingMapping}/ContinentsGetList`,
      { params }
    );
  }
  AccountSettingMappingCountryGetList(params: any): Observable<any> {
    return this.http.get<any>(
      `${this.environment.AppAccountSettingMapping}/CountrysGetList`,
      { params }
    );
  }
  AccountSettingMappingDistributorGetList(params: any): Observable<any> {
    return this.http.get<any>(
      `${this.environment.AppAccountSettingMapping}/DistributorGetListByCountryId`,
      { params }
    );
  }
  ProductSettingMappingBrandGetList(params: any): Observable<any> {
    return this.http.get<any>(
      `${this.environment.AppProductSettingMapping}/getlistBrand`,
      { params }
    );
  }
  ProductSettingMappingProductGroupGetList(params: any): Observable<any> {
    return this.http.get<any>(
      `${this.environment.AppProductSettingMapping}/getlistProductGroup`,
      { params }
    );
  }
  ProductSettingMappingProductFamilyGetList(params: any): Observable<any> {
    return this.http.get<any>(
      `${this.environment.AppProductSettingMapping}/getlistProductFamily`,
      { params }
    );
  }
  ProductSettingMappingParentProductGetList(params: any): Observable<any> {
    return this.http.get<any>(
      `${this.environment.AppProductSettingMapping}/getlistParentProduct`,
      { params }
    );
  }
  ProductSettingMappingParentProductLineList(params: any): Observable<any> {
    return this.http.get<any>(
      `${this.environment.AppProductSettingMapping}/ProductLineGet`,
      { params }
    );
  }
  FbForecastGetMeasureProfileList(params: any): Observable<any> {
    return this.http.get<any>(`${this.environment.FbForecastProfile}/getlist`, {
      params,
    });
  }
  MsForecastGetMeasureOrderList(params: any): Observable<any> {
    return this.http.get<any>(`${this.environment.MsForecastProfile}/getlist`, {
      params,
    });
  }
  FbForecastSaveMeasureProfile(params: any): Observable<any> {
    return this.http.post<any>(
      `${this.environment.FbForecastProfile}/add`,
      params
    );
  }
  FbForecastActivateMeasureProfile(params: any): Observable<any> {
    return this.http.put<any>(
      `${this.environment.FbForecastProfile}/activate`,
      params
    );
  }
  FbForecastDeleteMeasureProfile(params: any): Observable<any> {
    return this.http.put<any>(
      `${this.environment.FbForecastProfile}/Delete`,
      params
    );
  }
  FbForecastApplyMeasureProfile(params: any): Observable<any> {
    return this.http.put<any>(
      `${this.environment.FbForecastProfile}/Applied`,
      params
    );
  }
  MsForecastApplyMeasureOrderList(params: any): Observable<any> {
    return this.http.put<any>(
      `${this.environment.MsForecastProfile}/Applied`,
      params
    );
  }
  FbForecastMasterRefreshGet(params: any): Observable<any> {
    return this.http.post<any>(
      `${this.environment.AppFBForcast}/fbForecastMasterRefreshGet`,
      params
    );
  }
  FbForecastUpdateMeasureProfile(params: any): Observable<any> {
    return this.http.put<any>(
      `${this.environment.FbForecastProfile}/update`,
      params
    );
  }
  FbForecastUpdateDefaultMeasureProfile(params: any): Observable<any> {
    return this.http.put<any>(
      `${this.environment.FbForecastProfile}/DefaultUpdate`,
      params
    );
  }
  MsForecastUpdateMeasureOrderList(params: any): Observable<any> {
    return this.http.put<any>(
      `${this.environment.MsForecastProfile}/update`,
      params
    );
  }
  // Promotion Planner
  PromotionPlannerGetAll(params: any): Observable<any> {
    return this.http.get<any>(`${this.environment.PromotionPlanner}/getall`, {
      params,
    });
  }
  PromotionPlannerGetAdd(params: any): Observable<any> {
    return this.http.post<any>(
      `${this.environment.PromotionPlanner}/add`,
      params
    );
  }
  PromotionPlannerGetUpdate(params: any): Observable<any> {
    return this.http.put<any>(
      `${this.environment.PromotionPlanner}/update`,
      params
    );
  }
  PromotionPlannerGet(params: any): Observable<any> {
    return this.http.get<any>(`${this.environment.PromotionPlanner}/get`, {
      params,
    });
  }
  DataManagerMeasuresGetList(params: any): Observable<any> {
    return this.http.get<any>(
      `${this.environment.AppFBForcast}/dataManagerMeasuresGetList`,
      {
        params,
      }
    );
  }
  GetMethodManagerValues(params: any): Observable<any> {
    return this.http.get<any>(
      `${this.environment.AppFBForcast}/FbMeasureMasterGetByForecastMapping`,
      {
        params,
      }
    );
  }
  FbMeasureMasterGetByForecastMappingPerformance(params: any): Observable<any> {
    return this.http.post<any>(
      `${this.environment.AppFBForcast}/FbMeasureMasterGetByForecastMappingPerformance`,
      params
    );
  }
  FbForecastExport(params: any): Observable<any> {
    return this.http.post(`${this.environment.AppFBForcast}/export`, params, {
      observe: 'response',
      responseType: 'blob',
    });
  }
  FbForecastExportNew(requestPayload: any): Observable<any> {
    return this.http.post(`${this.environment.AppFBForcast}/ExportNew`, requestPayload);
  }
  FbForecastSpreadingAdd(params: any): Observable<any> {
    return this.http.post(
      `${this.environment.AppFBSpreading}/SpreadingAdd`,
      params
    );
  }
  FbForecastSpreadingAddList(params: any): Observable<any> {
    return this.http.post(
      `${this.environment.AppFBSpreading}/spreadingAddList`,
      params
    );
  }
  FbForecastSpreadingAddListDisti(params: any): Observable<any> {
    return this.http.post(
      `${this.environment.AppFBSpreading}/spreadingAddListDisti`,
      params
    );
  }
  FbForecastSpreadingAddDisti(params: any): Observable<any> {
    return this.http.post(
      `${this.environment.AppFBSpreading}/SpreadingAddDisti`,
      params
    );
  }
  FbForecastDefaultAdd(params: any): Observable<any> {
    return this.http.post(
      `${this.environment.AppFBForcast}/fbForecastDefaultAdd`,
      params
    );
  }

  fbForecastDefaultDelete(params: any): Observable<any> {
    return this.http.post(
      `${this.environment.AppFBForcast}/fbForecastDefaultDelete`,
      params
    );
  }
  FbForecastPlannerCopyMeasure(params: any): Observable<any> {
    return this.http.post(
      `${this.environment.AppFBForcast}/PlannerCopyMeasure`,
      params
    );
  }
  getLiveReports(params: any): Observable<any> {
    return this.http.get(`${this.environment.AppMenu}/getLiveReports`, {
      params,
    });
  }
  GetJobsHistory(params: any): Observable<any> {
    return this.http.get(`${this.environment.AppBulkCommit}/GetById`, {
      params,
    });
  }
  AddBulkCommitJob(params: any): Observable<any> {
    return this.http.post(
      `${this.environment.AppBulkCommit}/AddBulkCommit`,
      params
    );
  }
  CancelBulkCommitJob(params: any): Observable<any> {
    return this.http.put(
      `${this.environment.AppBulkCommit}/CancelJob`,
      params
    );
  }

  GetCurrentJobStatus(params: any): Observable<any> {
    return this.http.get(`${this.environment.AppBulkCommit}/GetStatusById`, {
      params,
    });
  }
  AddPriceAndPlannerPrediction(payload: any): Observable<any> {
    return this.http.post<any>(`${this.environment.AppBulkCommit}/PricePlannerPredictionAdd`, payload);
  }
  FbForecastSpreadingAddListAsync(params: any): Observable<any> {
    return this.http.post(
      `${this.environment.AppFBSpreading}/spreadingAddListAsync`,
      params
    );
  }
  SimulateSellIn(params: any): Observable<any> {
    return this.http.post(
      `${this.environment.AppFBForcast}/simulateSellIn`,
      params
    );
  }
  GetDocumentsByType(params: any): Observable<any> {
    return this.http.get<any>(`${this.environment.AppCommonCode}/UserDocumentsGet`, { params });
  }
  ItemAccountComboExport(params: any): Observable<any> {
    return this.http.post<any>(`${this.environment.AppCommonCode}/ItemAccountExport`, params);
  }
  ItemAccountComboGet(params: any): Observable<any> {
    return this.http.post<any>(`${this.environment.AppCommonCode}/ActiveItemAccountGet`, params);
  }
  PORDataConfigGet(params: any): Observable<any> {
    return this.http.get<any>(
      `${this.environment.AppCommonCode}/PORDataConfigGet`,
      { params }
    );
  }
  ConfigBulkUploads(params: any): Observable<any> {
    return this.http.post(
      `${this.environment.AppCommonCode}/ConfigBulkUploads`,
      params
    );
  }
  ExecPORDataConfig(params: any): Observable<any> {
    return this.http.post(
      `${this.environment.AppCommonCode}/PORDataConfig`,
      params
    );
  }
  MeasureDependancyAdd(params: any): Observable<any> {
    return this.http.post(
      `${this.environment.AppFBForcast}/MeasureDependancyAdd`,
      params
    );
  }
  MeasureDependancyGet(params: any): Observable<any> {
    return this.http.get(
      `${this.environment.AppFBForcast}/MeasureDependancyGet`,
      { params }
    );
  }
  MeasureMetaDataAdd(params: any): Observable<any> {
    return this.http.post(
      `${this.environment.AppFBForcast}/MeasureMetaDataAdd`,
      params
    );
  }
  MeasureMetaDataGet(params: any): Observable<any> {
    return this.http.get(
      `${this.environment.AppFBForcast}/MeasureMetaDataGet`,
      { params }
    );
  }
  MeasureMetaDataDelete(params: any): Observable<any> {
    return this.http.put(
      `${this.environment.AppFBForcast}/MeasureMetaDataDelete`,
      params
    );
  }
  GetBotProactiveAlerts(params: any): Observable<any> {
    return this.http.get<any>(
      `${this.environment.AppCommonCode}/GetBotProactiveAlerts`
    );
  }
  MeasuresGetListByMeasureTypeId(params: any): Observable<any> {
    return this.http.get(
      `${this.environment.AppFBForcast}/MeasuresGetListByMeasureTypeId`,
      { params }
    );
  }
  GetMeasuresListIsExportable(): Observable<any> {
    return this.http.get(
      `${this.environment.AppFBForcast}/GetMeasuresListIsExportable`);
  }
  GetBotAlerts(params: any): Observable<any> {
    return this.http.get<any>(
      `${this.environment.AppCommonCode}/GetBotAlerts`,
      { params }
    );
  }

  // Journey Lookups Endpoint
  GetJourneyLookups = (params: any) => {
    return this.http.get<any>(`${this.environment.AppJourneyLookUp}/get`, { params });
  };
  // Journey Lookups Endpoint

  // Journey Endpoints
  CreateJourney = (body: any) => {
    return this.http.post<any>(`${this.environment.AppJourney}/add`, body);
  };
  UpdateJourney = (body: any) => {
    return this.http.put<any>(`${this.environment.AppJourney}/update`, body);
  };
  GetJourney = (params: any) => {
    return this.http.get<any>(`${this.environment.AppJourney}/get`, { params });
  };
  JourneyGetList = (params: any) => {
    return this.http.get<any>(`${this.environment.AppJourney}/getList`, {
      params,
    });
  };
  JourneyGetAll = (params: any) => {
    return this.http.get<any>(`${this.environment.AppJourney}/getAll`, {
      params,
    });
  };
  JourneyGet = (params: any) => {
    return this.http.get<any>(`${this.environment.AppJourney}/Get`, {
      params,
    });
  };
  JourneyGetAllShared = (params: any) => {
    return this.http.get<any>(`${this.environment.AppJourney}/getAllShared`, {
      params,
    });
  };
  JourneyListGetWithUserId = (params: any) => {
    return this.http.get<any>(`${this.environment.AppJourney}/JourneyWithUserIdGet`, {
      params,
    });
  };
  DeleteJourney = (body: any) => {
    return this.http.put<any>(`${this.environment.AppJourney}/activate`, body);
  };
  JourneyViewed = (body: any) => {
    return this.http.put<any>(`${this.environment.AppJourney}/JourneyViewed`, body);
  };
  // Journey Endpoints
  // Journey Collaboration
  CreateJourneyCollaboration = (body: any) => {
    return this.http.post<any>(
      `${this.environment.AppJourneyCollaboration}/add`,
      body
    );
  };
  AddJourneyCollaborationList = (body: any) => {
    return this.http.post<any>(
      `${this.environment.AppJourneyCollaboration}/AddList`,
      body
    );
  };
  UpdateJourneyCollaboration = (body: any) => {
    return this.http.put<any>(
      `${this.environment.AppJourneyCollaboration}/update`,
      body
    );
  };
  GetJourneyCollaboration = (params: any) => {
    return this.http.get<any>(
      `${this.environment.AppJourneyCollaboration}/get`,
      { params }
    );
  };
  JourneyCollaborationGetList = (params: any) => {
    return this.http.get<any>(
      `${this.environment.AppJourneyCollaboration}/getList`,
      { params }
    );
  };
  JourneyCollaborationGetListNotViewed = (params: any) => {
    return this.http.get<any>(
      `${this.environment.AppJourneyCollaboration}/notViewed`,
      { params }
    );
  };

  JourneyNotificationCountByUser = (params: any) => {
    return this.http.get<any>(
      `${this.environment.NotificationCommon}/NotificationsCountByUserId`,
      { params }
    );
  };
  checkJourneyNameExists(journey: any): Observable<any> {
    return this.http.get<any>(
      `${this.environment.AppJourney}/JourneyNameExists?journeyName=${journey}`
    );
  }
  ViewedCountByUserId(userID: any): Observable<any> {
    return this.http.get<any>(
      `${this.environment.AppJourney}/UnViewedCountByUserId?CurrentUserId=${userID}`
    );
  }
  checkJourneyContextLogNameExists(journeyId: any, journeyContextName: any): Observable<any> {
    return this.http.get<any>(
      `${this.environment.AppJourneyContextLog}/JourneyContextLogNameExists?journeyContextName=${journeyContextName}&journeyId=${journeyId}`
    );
  }
  journeyNotificationCount = (body: any) => {
    return this.http.put<any>(
      `${this.environment.NotificationCommon}/ViewUpdate`,
      body
    );
  };
  JourneyContextViewed = (body: any) => {
    return this.http.put<any>(
      `${this.environment.AppJourneyContextLog}/JourneyContextViewed`,
      body
    );
  };


  JourneyCollaborationViewedAt = (body: any) => {
    return this.http.put<any>(
      `${this.environment.AppJourneyCollaboration}/viewedAt`,
      body
    );
  };
  DeleteJourneyCollaboration = (body: any) => {
    return this.http.put<any>(
      `${this.environment.AppJourneyCollaboration}/activate`,
      body
    );
  };
  // Journey Collaboration

  // Journey Context Log Endpoints
  CreateJourneyContextLog = (body: any) => {
    return this.http.post<any>(`${this.environment.AppJourneyContextLog}/add`, body);
  };
  UpdateJourneyContextLog = (body: any) => {
    return this.http.put<any>(`${this.environment.AppJourneyContextLog}/update`, body);
  };
  GetJourneyContextLog = (params: any) => {
    return this.http.get<any>(`${this.environment.AppJourneyContextLog}/get`, { params });
  };
  JourneyContextLogGetList = (params: any) => {
    return this.http.get<any>(`${this.environment.AppJourneyContextLog}/getList`, {
      params,
    });
  };
  DeleteJourneyContextLog = (body: any) => {
    return this.http.put<any>(`${this.environment.AppJourneyContextLog}/activate`, body);
  };

  // Journey Context Log Endpoints

  // Journey Context Log Comment Endpoints
  CreateJourneyContextLogComment = (body: any) => {
    return this.http.post<any>(
      `${this.environment.AppJourneyContextLogComment}/create`,
      body
    );
  };

  UpdateJourneyContextLogComment = (body: any) => {
    return this.http.put<any>(`${this.environment.AppJourneyContextLogComment}/update`, body);
  };
  DeleteJourneyContextLogComment = (body: any) => {
    return this.http.put<any>(`${this.environment.AppJourneyContextLogComment}/activate`, body);
  };
  JourneyContextLogCommentGetList = (params: any) => {
    return this.http.get<any>(
      `${this.environment.AppJourneyContextLogComment}/getList`,
      { params }
    );
  };
  JourneyContextLogCommentGetById = (params: any) => {
    return this.http.get<any>(
      `${this.environment.AppJourneyContextLogComment}/getById`,
      { params }
    );
  };

  // Journey Context Log Comment Endpoints
  //Journey Insight Comments
  GetJourneyInsightCommentsList = (params: any) => {
    return this.http.get<any>(
      `${this.environment.AppJourneyInsightComments}/Getlist`,
      { params }
    );
  };
  CreateJourneyInsightComments = (body: any) => {
    return this.http.post<any>(
      `${this.environment.AppJourneyInsightComments}/create`,
      body
    );
  };
  DeleteJourneyInsightComments = (body: any) => {
    return this.http.put<any>(`${this.environment.AppJourneyInsightComments}/Activate`, body);
  };
  UpdateJourneyInsightComments = (body: any) => {
    return this.http.put<any>(`${this.environment.AppJourneyInsightComments}/update`, body);
  };
  // Journey Insight Comments
  // Journey Activity Log
  JourneyUserActivityLogGetList = (params: any) => {
    return this.http.get<any>(
      `${this.environment.AppJourneyUserActivityLog}/getList`,
      { params }
    );
  };
  JourneyUserActivityLogGetAll = (params: any) => {
    return this.http.get<any>(
      `${this.environment.AppJourneyUserActivityLog}/getAll?${params}`
    );
  };

  // Journey Activity Log

  // User Grid Preference
  CreateUserPreference = (body: any) => {
    return this.http.post<any>(
      `${this.environment.AppUserPreference}/add`,
      body
    );
  };
  UserPreferenceGetList = (params: any) => {
    return this.http.get<any>(
      `${this.environment.AppUserPreference}/getList`,
      { params }
    );
  };
  // User Grid Preference

  // Task
  CreateTask = (body: any) => {
    return this.http.post<any>(
      `${this.environment.AppTask}/add`,
      body
    );
  };
  UpdateTask = (body: any) => {
    return this.http.put<any>(
      `${this.environment.AppTask}/update`,
      body
    );
  };
  TaskViewed = (body: any) => {
    return this.http.put<any>(
      `${this.environment.AppTask}/TaskViewed`,
      body
    );
  };
  GetTask = (params: any) => {
    return this.http.get<any>(
      `${this.environment.AppTask}/get`,
      { params }
    );
  };
  DeleteTask = (body: any) => {
    return this.http.put<any>(`${this.environment.AppTask}/activate`, body);
  };
  TaskGetList = (params: any) => {
    return this.http.get<any>(
      `${this.environment.AppTask}/getList`,
      { params }
    );
  };
  AssignTaskToUsers = (body: any) => {
    return this.http.put<any>(
      `${this.environment.AppTask}/assignedAdd`,
      body
    );
  };
  TaskGetAssignedList = (params: any) => {
    return this.http.get<any>(
      `${this.environment.AppTask}/getAssignedList`,
      { params }
    );
  };
  TaskGetAssignees = (params: any) => {
    return this.http.get<any>(
      `${this.environment.AppTask}/getAssignees`,
      { params }
    );
  };
  // Task
  // Task Request
  CreateTaskRequest = (body: any) => {
    return this.http.post<any>(
      `${this.environment.AppTaskRequest}/add`,
      body
    );
  };
  UpdateTaskRequest = (body: any) => {
    return this.http.put<any>(
      `${this.environment.AppTaskRequest}/update`,
      body
    );
  };
  GetTaskRequest = (params: any) => {
    return this.http.get<any>(
      `${this.environment.AppTaskRequest}/get`,
      { params }
    );
  };
  DeleteTaskRequest = (body: any) => {
    return this.http.put<any>(`${this.environment.AppTaskRequest}/activate`, body);
  };
  TaskRequestGetList = (params: any) => {
    return this.http.get<any>(
      `${this.environment.AppTaskRequest}/getList`,
      { params }
    );
  };
  createContextLog = (body: any) => {
    return this.http.post<any>(
      `${this.environment.AppJourney}/CreateContextLog`,
      body
    );
  };
  getJourneyComments(data: number) {
    return this.http.get<any>(
      `${this.environment.AppJourney}/GetJourneyComments?JourneyId=${data}`
    );
  }
  setJourneyComments(body: any) {
    return this.http.post<any>(
      `${this.environment.AppJourney}/CreateJourneyComments`,
      body
    );
  }
  createJourneyCollaborations(body: any) {
    return this.http.post<any>(
      `${this.environment.AppJourney}/CreateJourneyCollaborations`,
      body
    );
  }
  GetSharedJourneyByCollaborationId(JourneyCollaborationId: any) {
    return this.http.get<any>(
      `${this.environment.AppJourney}/GetSharedJourneyByCollaborationId?JourneyCollaborationId=${JourneyCollaborationId}`
    );
  }
  getJourneyCollaboration(
    SharedBy: number | any = null,
    sharedWith: number | any = null,
    journeyId: number | any = null
  ) {
    if (SharedBy) {
      return this.http.get<any>(
        `${this.environment.AppJourney}/GetJourneyCollaboration?SharedBy=${SharedBy}`
      );
    } else if (sharedWith) {
      return this.http.get<any>(
        `${this.environment.AppJourney}/GetJourneyCollaboration?SharedWith=${sharedWith}`
      );
    } else if (journeyId) {
      return this.http.get<any>(
        `${this.environment.AppJourney}/GetJourneyCollaboration?JourneyId=${journeyId}`
      );
    } else {
      return of(
        'Invalid Argument, set one or more parameter to execute this method.'
      );
    }
  }
  UpdateContextLog = (body: any) => {
    return this.http.put<any>(
      `${this.environment.AppJourney}/UpdateContextLog`,
      body
    );
  };
  GetJourneyByUserId(CreatedBy: number) {
    return this.http.get<any>(
      `${this.environment.AppJourney}/GetJourneyByUserId?CreatedBy=${CreatedBy}`
    );
  }
  // DeleteJourney(journeyId: number) {
  //   return this.http.delete<any>(
  //     `${this.environment.AppJourney}/DeleteJourney?JourneyId=${journeyId}`
  //   );
  // }
  GetContextLog(journeyId: number) {
    return this.http.get<any>(
      `${this.environment.AppJourney}/GetContextLog?JourneyId=${journeyId}`
    );
  }
  // DeleteJourneyCollaboration(journeyId: number, sharedWith: number) {
  //   return this.http.delete<any>(
  //     `${this.environment.AppJourney}/DeleteJourneyCollaboration?JourneyId=${journeyId}&SharedWith=${sharedWith}`
  //   );
  // }
  GetNotViewedJourneys(userId: number) {
    return this.http.get<any>(
      `${this.environment.AppJourney}/GetNotViewedJourneys?SharedWith=${userId}`
    );
  }
  UpdateJourneyViewedAt = (body: any) => {
    return this.http.put<any>(
      `${this.environment.AppJourney}/UpdateJourneyViewedAt`,
      body
    );
  };
  DeleteReportByGroupId(groupId: string, reportId: string) {
    return this.http.delete<any>(
      `${this.environment.AppPowerBi}/DeleteReportByGroupId?GroupId=${groupId}&ReportId=${reportId}`
    );
  }
  DeleteContextLog = (Id: number) => {
    return this.http.delete<any>(
      `${this.environment.AppJourney}/DeleteContextLog?Id=${Id}`
    );
  };
  GetUserAutoCompleteLists(id: any): Observable<any> {
    return this.http.get<any>(
      `${this.environment.autoCompleteApi}/get_lists/${id}`
    );
  }
  GetAllJourneys() {
    return this.http.get<any>(`${this.environment.AppJourney}/GetAllJourneys`);
  }
  GetAllReports() {
    return this.http.get<any>(`${this.environment.AppCommonCode}/GetReports`);
  }
  GetReportFilters(params: any) {
    return this.http.get<any>(`${this.environment.AppCommonCode}/GetFilters?MenuId=` + params);
  }
  ExportReport(params: any): Observable<any> {
    return this.http.post(
      `${this.environment.AppCommonCode}/ExportToCSV/Excel`,
      params
    );
  }
  GetFileExtraction = (data: any) => {
    return this.http.get<any>(`${this.environment.AppFileExtractor}/FileExtractionGetList?` + data);
  };
  AddFileExtraction(params: any): Observable<any> {
    return this.http.post(
      `${this.environment.AppFileExtractor}/FileExtractionAdd`,
      params
    );
  }
  BackgroundJobCancel(params: any): Observable<any> {
    return this.http.post(
      `${this.environment.AppBackgroundJob}/BackgroundJobCancel`,
      params
    );
  }
   GetAllBackgroundJobTypes() {
    return this.http.get<any>(`${this.environment.AppBackgroundJob}/GetBackgroundJobTypes`);
  }
  SchedulerCancel(params: any): Observable<any> {
    return this.http.post(
      `${this.environment.Scheduler}/SchedulerCancel`,
      params
    );
  }
  GetBackgroundJobGetList = (data: any) => {
    return this.http.get<any>(`${this.environment.AppBackgroundJob}/BackgroundJobGetList?` + data);
  };

  SchedulerGetList = (params: any) => {
    return this.http.post<any>(`${this.environment.Scheduler}/GetSchedulerList`, params);
  };


  BackgroundJobAdd(params: any): Observable<any> {
    return this.http.post(
      `${this.environment.AppBackgroundJob}/BackgroundJobAdd`,
      params
    );
  }
  GetBackgroundJobDetail = (JobId: any, JobTypeId: any) => {
    return this.http.get<any>(`${this.environment.AppBackgroundJob}/BackgroundJobDetailByIdGet?JobId=` + JobId + '&JobTypeId=' + JobTypeId);
  };
  SchedulerAdd(params: any): Observable<any> {
    return this.http.post(
      `${this.environment.Scheduler}/AddScheduler`,
      params
    );
  }
  SchedulerEdit(params: any): Observable<any> {
    return this.http.post(
      `${this.environment.Scheduler}/EditScheduler`,
      params
    );
  }
  GetUserReports(params: any) {
    return this.http.get<any>(`${this.environment.AppCommonCode}/ReportsGetById?${params}`);
  }

  GenAIProcessCSV = (model: any) => {
    const payload = new FormData()
    payload.append('file', model.file),
      payload.append('user_name', model.user_name)

    return this.http.post<any>(this.environment.GenAiapi + `/process_csv`, payload);
  }
  GenAIProcessLink = (model: any) => {
    const payload = new FormData()
    payload.append('file_link', model.file_link),
      payload.append('user_name', model.user_name)
    return this.http.post<any>(this.environment.GenAiapi + `/process_link`, payload);
  }
  GetGenAiData = (model: any) => {
    // const payload = new FormData()
    // payload.append('record_pk', model.byocKey);
    return this.http.get<any>(this.environment.GenAiapi + `/get_file_data?record_pk=${model.byocKey}`);
  }

  AskFromCSV = (model: any) => {
    const payload = new FormData()
    payload.append('question', model.question),
      payload.append('user_name', model.user_name);
    payload.append('record_pk', model.record_pk);

    return this.http.post<any>(this.environment.GenAiapi + '/ask', payload);
  }

  AddSubscription = (body: any) => {
    return this.http.post<any>(
      `${this.environment.AppSubscription}/journeySubscriptionAdd`,
      body
    );
  };
  SubscriptionGet = (params: any) => {
    return this.http.get<any>(
      `${this.environment.AppSubscription}/journeySubscriptionGet`,
      { params }
    );
  };
  setColumnMetaData = (model: any) => {
    return this.http.post<any>(this.environment.GenAiapi + '/set_col_description', model);
  }

  getColumnsMetaData = (model: any) => {
    const payload = new FormData()
    payload.append('user_name', model.user_name)
    return this.http.post<any>(this.environment.GenAiapi + '/get_col_description', payload);
  }

  // public Journey

  GetAllPublicJourneys = (params: any) => {
    return this.http.get<any>(`${this.environment.AppJourney}/GetAllPublicJourneys`, {
      params,
    });
  };

  journeyRequestAccessAdd = (body: any) => {
    return this.http.post<any>(`${this.environment.AppJourney}/JourneyRequestAccessAdd`, body);
  };
  JourneyRequestAccessDelete = (body: any) => {
    return this.http.post<any>(`${this.environment.AppJourney}/JourneyRequestAccessDelete`, body);
  };
  GetNotificationUsersById = (params: any) => {
    return this.http.get<any>(`${this.environment.NotificationCommon}/GetNotificationUsersById?`, {
      params,
    });
  };

  GetFilteredByUserId = (body: any) => {
    return this.http.post<any>(`${this.environment.NotificationCommon}/GetFilteredByUserId`, body);
  };
  JourneyRequestAccessApprove = (body: any) => {
    return this.http.post<any>(`${this.environment.AppJourney}/JourneyRequestAccessApprove`, body);
  };
  JourneyRequestAccessGet = (params: any) => {
    return this.http.get<any>(`${this.environment.AppJourney}/JourneyRequestAccessGet`, {
      params,
    });
  };

  // KPI Subscription

  AddKpiSubscription = (body: any) => {
    return this.http.post<any>(`${this.environment.KPISubscription}/addlist`, body);
  };

  unsubscribeAlerts = (body: any) => {
    return this.http.put<any>(`${this.environment.KPISubscription}/kpisharedalertsactivate`, body);
  };

  getSharedWithUserSubscription = (body: any) => {
    return this.http.get<any>(`${this.environment.KPISubscription}/getsharedalertwithuserList?SharedWithUser=${body}`);
  };

  getUserKpis = (body: any) => {
    return this.http.get<any>(`${this.environment.KPISubscription}/getlist?SubscribedBy=${body}`);
  };

  getShareKPIList(userid: any) {
    return this.http.get<any>(`${this.environment.KPISubscription}/getlist?SubscribedBy=${userid}`)
  }

  getKpiList = (report: any) => {
    return this.http.get<any>(`${this.environment.KPIList}/getlist?OriginalReportId=${report}`)
  }

  getCoreArea = () => {
    return this.http.get<any>(`${this.environment.CoreArea}/getList`)
  }

  getReports = (coreId: any) => {
    return this.http.get<any>(`${this.environment.KPISlicer}/ReportsGetListByCoreArea?CoreAreaId=${coreId}`)
  }
  getReports_v2 = (coreId: any) => {
    return this.http.get<any>(`${this.environment.KPIList}/GetReportsByCoreArea?CoreAreaId=${coreId}`)
  }
  GetReportsByCoreArea = (coreId: any) => {
    return this.http.get<any>(`${this.environment.KPIList}/GetReportsByCoreArea?CoreAreaId=${coreId}`)
  }

  getKPIs = (reportId: any) => {
    return this.http.get<any>(`${this.environment.KPIList}/getlist?OriginalReportId=${reportId}`)
  }
  getKPIs_v2 = (reportId: any) => {
    return this.http.get<any>(`${this.environment.KPIList}/getlist_v2?OriginalReportId=${reportId}`)
  }
  getCoreAreabyReportId = (reportId: any) => {
    return this.http.get<any>(`${this.environment.KPIList}/GetCoreAreaByReportId?OriginalReportId=${reportId}`)
  }
  addUserGraph = (body: any) => {
    return this.http.post<any>(`${this.environment.Homebase}/KPIUserGraphAdd`, body)
  }

  getGraph = (params: any) => {
    return this.http.get<any>(`${this.environment.Homebase}/get?KPIUserGraphId=${params}`)
  }

  addKpiGraph = (body: any) => {
    return this.http.post<any>(`${this.environment.Homebase}/KPIUserGraphAddList`, body)
  }
  KPIUserGraphGetById = (kpiId: any) => {
    return this.http.get<any>(`${this.environment.Homebase}/KPIUserGraphGetById?KPIUserGraphId=${kpiId}`)
  }

  KPIUserGraphGetList = (reportId: any, userId: any) => {
    return this.http.get<any>(`${this.environment.Homebase}/KPIUserGraphGetList?reportId=${reportId}&CurrentUserId=${userId}`)
  }

  KPIUserGraphActivate = (body: any) => {
    return this.http.put<any>(`${this.environment.Homebase}/KPIUserGraphActivate`, body);
  }

  getGraphReportsCoreAreaUserId_V2 = (coreId: any, userId: any) => {
    return this.http.get<any>(`${this.environment.KPIList}/GetGraphsReportsListByCoreArea?CoreAreaId=${coreId}&SubscribedBy=${userId}`)
  }
  getGraphs = (pageId: any) => {
    return this.http.get<any>(`${this.environment.Homebase}/getreportvisualslist?PageId=${pageId}`)
  }
  getGraphs_v2 = (pageId: any) => {
    return this.http.get<any>(`${this.environment.Homebase}/getvisualsbypageid?PageId=${pageId}`)
  }
  getTiles = (reportId: any) => {
    return this.http.get<any>(`${this.environment.Homebase}/gettilesbyreportid?ReportId=${reportId}`)
  }

  getPages = (reportId: any) => {
    return this.http.get<any>(`${this.environment.Homebase}/getpageslistbyreportid?ReportId=${reportId}`)
  }
  getPages_v2 = (reportId: any) => {
    return this.http.get<any>(`${this.environment.Homebase}/getpagesbyreportid?ReportId=${reportId}`)
  }

  getFilters = (reportId: any) => {
    return this.http.get<any>(`${this.environment.KPISlicer}/GetKPISlicerAndValuesList?OriginalReportId=${reportId}`)
  }

  addKPI = (body: any) => {
    return this.http.post<any>(`${this.environment.KPISubscription}/addList`, body)
  }

  // addGraph=(body: any)=>{
  //   return this.http.post<any>(`${this.environment.Homebase}/adduservisual`, body)
  // }

  addTile = (body: any) => {
    return this.http.post<any>(`${this.environment.Homebase}/addusertile`, body)
  }

  addGraph_v2 = (body: any) => {
    return this.http.post<any>(`${this.environment.Homebase}/adduservisual_v2`, body)
  }

  getKpiSubscriptions = (userId: any) => {
    return this.http.get<any>(`${this.environment.KPISubscription}/KpiSubscriptionsByUserIdGetList?SubscribedBy=${userId}`)
  }

  getKpiSubscriptionsProgress = (subscriptionId: any) => {
    return this.http.get<any>(`${this.environment.KPITrack}/getlist?KPISubscriptionId=${subscriptionId}`)
  }

  getKpiErrorLogs = (subscriptionId: any) => {
    return this.http.get<any>(`${this.environment.KPIError}/getlist?KPISubscriptionId=${subscriptionId}`)
  }

  testKpi = (body: any) => {
    return this.http.post<any>(`${this.environment.KPISubscription}/getkpialertvalue`, body)
  }

  getKpiGraphs = (userId: any) => {
    return this.http.get<any>(`${this.environment.Homebase}/getuservisualslist?CreatedById=${userId}`)
  }

  getKpiGraphs_v2 = (userId: any) => {
    return this.http.get<any>(`${this.environment.Homebase}/getuservisualslist_v2?CreatedById=${userId}`)
  }

  getKpiTileGraphs = (userId: any) => {
    return this.http.get<any>(`${this.environment.Homebase}/getusertileslist?CreatedById=${userId}`)
  }

  JourneyCollaborationGetUserList = (params: any) => {
    return this.http.get<any>(
      `${this.environment.AppJourneyCollaboration}/JourneyContextLogUsersGetList`,
      { params }
    );
  };
  GetNotificationsByUserId = (params: any) => {
    return this.http.get<any>(
      `${this.environment.NotificationCommon}/GetByUserId`,
      { params }
    );
  };
  NotificationRead = (model: any) => {
    return this.http.put<any>(`${this.environment.NotificationCommon}/read`, model);
  };
  getKpiSubscriptionsdashboard = (userId: any) => {
    return this.http.get<any>(`${this.environment.KPISubscription}/KPIHomePageGetByUserId?userId=${userId}`)
  }
  UpdateKpiDashboard = (body: any) => {
    return this.http.put<any>(`${this.environment.KPISubscription}/UpdateKpiDashboard`, body)
  }
  getKpiGraphdashboard = (userId: any) => {
    return this.http.get<any>(`${this.environment.Homebase}/getgraphslistbyuserid?CreatedById=${userId}`)
  }
  getKpiGraphdashboard_v2 = (userId: any) => {
    return this.http.get<any>(`${this.environment.Homebase}/GetGraphTilesListByUserId?CreatedById=${userId}`)
  }
  UpdateKpiGraphDashboard = (body: any) => {
    return this.http.put<any>(`${this.environment.Homebase}/updategraphforhomebase`, body)
  }

  getReportsCoreAreaUserId = (coreId: any, userId: any) => {
    return this.http.get<any>(`${this.environment.KPIList}/GetReportsListByCoreArea?CoreAreaId=${coreId}&SubscribedBy=${userId}`)
  }
  getGraphReportsCoreAreaUserId = (coreId: any, userId: any) => {
    return this.http.get<any>(`${this.environment.KPIList}/GetGraphsReportsListByCoreArea?CoreAreaId=${coreId}&SubscribedBy=${userId}`)
  }
  getVisualsList = () => {
    return this.http.get<any>(`${this.environment.KPITile}/GetList`)
  }
  updateTileName = (body: any) => {
    return this.http.put<any>(`${this.environment.KPITile}/UpdateKPITileTitleByKPITileId`, body)
  }
  itemHierarchyActivate = (body: any) => {
    return this.http.put<any>(`${this.environment.ItemHierarchy}/ItemHierarchyDataActivate`, body)
  }
  ItemHierarchyGetAll = (params: any) => {
    return this.http.get<any>(`${this.environment.ItemHierarchy}/GetAll`, { params })
  }
  ItemHierarchyGetAllTree = (params: any) => {
    const response: any = 'text';
    return this.http.post<any>(`${this.environment.ItemHierarchy}/GetAllTree`, params, { responseType: response })
  }
  GetbyPositionandParent = (params: any) => {
    return this.http.get<any>(`${this.environment.ItemHierarchy}/GetItemHierarchyDataByParentId`, { params })
  }
  GetbyIHDID = (itemHierarchyDataId: any) => {
    return this.http.get<any>(`${this.environment.ItemHierarchy}/GetItemHierarchyDataByIhdId?Ihd_Id=${itemHierarchyDataId}`)
  }

  AddItemHierarchyLevel = (body: any) => {
    return this.http.post<any>(`${this.environment.ItemHierarchy}/Add`, body)
  }
  UpdateItemHierarchyLevel = (body: any) => {
    return this.http.post<any>(`${this.environment.ItemHierarchy}/Update`, body)
  }
  DeleteItemHierarchyLevel = (body: any) => {
    return this.http.delete<any>(`${this.environment.ItemHierarchy}/Delete`, body)
  }
  AddItemHierarchyData = (body: any) => {
    return this.http.post<any>(`${this.environment.ItemHierarchy}/ItemHierarchyDataAdd`, body)
  }
  UpdateItemHierarchyData = (body: any) => {
    return this.http.post<any>(`${this.environment.ItemHierarchy}/ItemHierarchyDataUpdate`, body)
  }
  DeleteItemHierarchyData = (body: any) => {
    return this.http.delete<any>(`${this.environment.ItemHierarchy}/Delete`, body)
  }
  ItemHierarchyGetList = (params: any) => {
    return this.http.get<any>(`${this.environment.ItemHierarchy}/GetList`, { params })
  }
  ItemExportToCSVExcel(params: any): Observable<any> {
    return this.http.post(`${this.environment.ItemHierarchy}/ExportToCSV/Excel`, params, {
      observe: 'response',
      responseType: 'blob',
    });
  }
  CalendarExportToCSVExcel(params: any): Observable<any> {
    return this.http.post(`${this.environment.CalendarHierarchy}/ExportToCSV/Excel`, params, {
      observe: 'response',
      responseType: 'blob',
    });
  }
  GetTimeFrameList = () => {
    return this.http.get<any>(`${this.environment.CalendarHierarchy}/GetTimeFrame`)
  }
  AccountExportToCSVExcel(params: any): Observable<any> {
    return this.http.post(`${this.environment.AccountHierarchy}/ExportToCSV/Excel`, params, {
      observe: 'response',
      responseType: 'blob',
    });
  }
  AccountHierarchyGetAll = (params: any) => {
    return this.http.get<any>(`${this.environment.AccountHierarchy}/GetAll`, { params })
  }
  GetbyAccountDataAHDID = (accountHierarchyDataId: any) => {
    return this.http.get<any>(`${this.environment.AccountHierarchy}/GetAccountHierarchyDataByAhdId?Ahd_Id=${accountHierarchyDataId}`)
  }
  AccountHierarchyGetAllTree = (params: any) => {
    const response: any = 'text';
    return this.http.post<any>(`${this.environment.AccountHierarchy}/GetAllTree`, params, { responseType: response })
  }
  GetAccountHierarchyDataByParentId = (params: any) => {
    return this.http.get<any>(`${this.environment.AccountHierarchy}/GetAccountHierarchyDataByParentId`, { params })
  }

  CalendarHierarchyGetAll = (params: any) => {
    // return this.http.get<any>(`${this.environment.CalendarHierarchy}/GetAll`, {params})
    const response: any = 'text';
    return this.http.post<any>(`${this.environment.CalendarHierarchy}/GetAllTree`, params, { responseType: response })
  }
  GetCalendarHierarchyDataByParentId = (params: any) => {
    return this.http.get<any>(`${this.environment.CalendarHierarchy}/GetCalendarHierarchyDataByParentId`, { params })
  }
  GetCalendarHierarchyDataByChdId = (params: any) => {
    return this.http.get<any>(`${this.environment.CalendarHierarchy}/GetCalendarHierarchyDataByChdId`, { params })
  }
  AddAccountHierarchyData = (body: any) => {
    return this.http.post<any>(`${this.environment.AccountHierarchy}/AddAccountHierarchyData`, body)
  }
  AddCalendarHierarchyData = (body: any) => {
    return this.http.post<any>(`${this.environment.CalendarHierarchy}/AddCalendarHierarchyData`, body)
  }
  UpdateAccountHierarchyData = (body: any) => {
    return this.http.post<any>(`${this.environment.AccountHierarchy}/UpdateAccountHierarchyData`, body)
    // return this.http.post<any>(`${this.environment.AccountHierarchy}/ItemHierarchyDataUpdate`, body)
  }
  UpdateCalendarHierarchyData = (body: any) => {
    return this.http.post<any>(`${this.environment.CalendarHierarchy}/UpdateCalendarHierarchyData`, body)
  }


  GetAccountHierarchyData = (Id: any) => {
    return this.http.get<any>(`${this.environment.AccountHierarchy}/GetAccountHierarchyData?ID=${Id}`)
  }
  GetFbTemplates = () => {
    return this.http.get<any>(`${this.environment.AccountHierarchy}/GetFbTemplates`)
  }
  AddAccountHierarchyLevel = (body: any) => {
    return this.http.post<any>(`${this.environment.AccountHierarchy}/Add`, body)
  }
  AddAccountHierarchy = (body: any) => {
    return this.http.post<any>(`${this.environment.AccountHierarchy}/AddAccountHierarchy`, body)
  }
  AddcalendarHierarchy = (body: any) => {
    return this.http.post<any>(`${this.environment.CalendarHierarchy}/AddCalendarHierarchy`, body)
  }
  UpdateAccountHierarchy = (body: any) => {
    return this.http.post<any>(`${this.environment.AccountHierarchy}/UpdateAccountHierarchy`, body)
  }
  UpdateCalendartHierarchy = (body: any) => {
    return this.http.post<any>(`${this.environment.CalendarHierarchy}/UpdateCalendarHierarchy`, body)
  }
  UpdateAccountHierarchyLevel = (body: any) => {
    return this.http.post<any>(`${this.environment.AccountHierarchy}/Update`, body)
  }
  DeleteAccountHierarchyLevel = (body: any) => {
    return this.http.delete<any>(`${this.environment.AccountHierarchy}/Delete`, body)
  }
  AccountHierarchyGetList = (params: any) => {
    return this.http.get<any>(`${this.environment.AccountHierarchy}/GetList`, { params })
  }
  CalendarHierarchyGetList = (params: any) => {
    return this.http.get<any>(`${this.environment.CalendarHierarchy}/GetList`, { params })
  }
  getCronSchedule = () => {
    return this.http.get<any>(`${this.environment.CronSchedule}/getlist`)
  }
  getKpiSubscriptionSlicers(KpiSubscriptionId: any): Observable<any> {
    return this.http.get<any>(`${this.environment.KPISubscription}/GetKPIFiltersByKPISubscriptionId?KPISubscriptionId=${KpiSubscriptionId}`)
  }

  testKpiFilter = (body: any) => {
    return this.http.post<any>(`${this.environment.KPISubscription}/getfalseaggregatedkpifilters`, body)
  }

  testKpiFilterGrainAndAggregate = (body: any) => {
    return this.http.post<any>(`${this.environment.KPISubscription}/GetKPIAlertValueWithFilterHierarchy`, body)
  }
  getGrainLevelTrackingValues = (KpiSubscriptionId: any) => {
    return this.http.get<any>(`${this.environment.KPISubscription}/getGrainLevelTrackingValues?KPISubscriptionId=${KpiSubscriptionId}`)
  }
  getGrainHistoryTrackingValues = (model: any) => {
    return this.http.get<any>(`${this.environment.KPISubscription}/getGrainHistoryTrackingValues?KPISubscriptionId=${model.KpiSubscriptionId}&KPIGrainLevelCombinationId=${model.KpiGrainLevelCombinationId}`)
  }
  GetValueTagByFilters = (model: any) => {
    return this.http.post<any>(`${this.environment.AppJourneyContextLog}/GetValueTag`, model)
  }
  addKpiSubscription = (model: any) => {
    return this.http.post<any>(`${this.environment.KPISubscription}/KpiSubscriptionAddNew`, model)
  }
  GetAllCombinationsKpiALertValue = (model: any) => {
    return this.http.post<any>(`${this.environment.KPISubscription}/GetAllCombinationsKpiALertValue`, model)
  }
  KpiSubscriptionShareUnsubscribe = (body: any) => {
    return this.http.put<any>(`${this.environment.KPISubscription}/KpiSubscriptionShareUnsubscribe`, body)
  }
  KPISubscriptionDelete = (body: any) => {
    return this.http.put<any>(`${this.environment.KPISubscription}/KPISubscriptionDelete`, body)
  }
  KPISubscriptionAlertActive = (model: any) => {
    return this.http.put<any>(`${this.environment.KPISubscription}/UpdateKpiAlertStatus`, model)
  }
  //GetNextKPICombinations
  GetNextKPICombinations = (model: any) => {
    return this.http.post<any>(`${this.environment.KPISubscription}/GetNextKPICombinations`, model)
  }
  KpiSubscriptionsGetById(KpiSubscriptionId: any): Observable<any> {
    return this.http.get<any>(`${this.environment.KPISubscription}/KpiSubscriptionsGetById?KPISubscriptionId=${KpiSubscriptionId}`)
  }
  KpiSubscriptionsUserCreatedGetById = (userId: any) => {
    return this.http.get<any>(`${this.environment.KPISubscription}/KpiSubscriptionsUserCreatedGetById?SubscribedBy=${userId}`)
  }
  updateGrainCombination = (model: any) => {
    return this.http.put<any>(`${this.environment.KPISubscription}/KpiGrainCombinationUpdateHomeBase`, model)
  }
  ShareKpiSubscription = (model: any) => {
    return this.http.post<any>(`${this.environment.KPISubscription}/ShareKpiSubscription`, model)
  }
  GetExportableMeasures(): Observable<any> {
    return this.http.get(
      `${this.environment.AppFBForcast}/GetExportableMeasures`,
    );
  }
  GetClientAliasString = (params: any) => {
    return this.http.get<any>(`${this.environment.AppGetClientAlias}/GetClientAliasString`, { params })
  }

  GetAllReportsByUser = (userId: any) => {
    return this.http.get<any>(`${this.environment.AppCommonCode}/GetReports?userId=${userId}`);
  };

  GenerateCombinationsFromFilters(model: Array<any>) {
    return this.http.post<any>(`${this.environment.AppCommonCode}/GenerateCombinationsFromFilters`, model)
  }
  UpdateOrderAndParentId = (Menu: any) => {
    return this.http.put(`${this.environment.AppMenu}/UpdateOrderAndParentId`, Menu);
  };
  hideMenu = (Menu: any) => {
    return this.http.put(`${this.environment.AppMenu}/hide`, Menu);
  };

  // scenario planning
  UserPlannerScenarioAdd(FbForecast: any): Observable<number> {
    return this.http.post<number>(
      `${this.environment.AppFBForcast}/UserPlannerScenarioAdd`,
      FbForecast
    );
  }
  CurrencyRateGetList = (params: any) => {
    return this.http.get<any>(`${this.environment.AppCurrencyRate}/getlist`, { params })
  }
  GetLockCurrencyRatelist = (params: any) => {
    return this.http.get<any>(`${this.environment.AppCurrencyRate}/getLockCurrencyRatelist`, { params })
  }
  DeleteCurrencyRate = (body: any) => {
    return this.http.put<any>(
      `${this.environment.AppCurrencyRate}/activate`, body);
  };

  addCurrencyRate = (body: any) => {
    return this.http.post<any>(
      `${this.environment.AppCurrencyRate}/add`, body);
  };

  lockCurrencyRate = (body: any) => {
    return this.http.post<any>(
      `${this.environment.AppCurrencyRate}/lockCurrencyRate`, body);
  };

  UpdateCurrencyRate = (body: any) => {
    return this.http.put(`${this.environment.AppCurrencyRate}/Update`, body);
  };
  GetPPJobStatus(params: any): Observable<any> {
    return this.http.get(`${this.environment.AppBulkCommit}/GetPPJobStatus`, {
      params,
    });
  }
  ClientConfigurationGetList(params: any): Observable<any> {
    return this.http.get(`${this.environment.AppClientConfigurations}/GetList`, {
      params
    });
  }
  ClientConfigurationAdd(params: any): Observable<any> {
    return this.http.post(`${this.environment.AppClientConfigurations}/add`, params);
  }
  ClientConfigurationUpdate(params: any): Observable<any> {
    return this.http.put(`${this.environment.AppClientConfigurations}/update`, params);
  }
  ClientConfigurationDelete(params: any): Observable<any> {
    return this.http.put(`${this.environment.AppClientConfigurations}/activate`, params);
  }
  getReplJobBySchedularId(params: any): Observable<any> {
    return this.http.get(`${this.environment.Scheduler}/GetReplJobBySchedularId?SchedulerId=${params}`);
  }
  UpdateActiveItemAccount(params: any): Observable<any> {
    return this.http.post(
      `${this.environment.AppCommonCode}/UpdateActiveItemAccount`,
      params
    );
  }
  ActiveItemAccountDelete(params: any): Observable<any> {
    return this.http.post<any>(`${this.environment.AppCommonCode}/ActiveItemAccountDelete`, params);
  }
  GetAccountHierarchyDataByParentIds = (params: any) => {
    return this.http.post<any>(`${this.environment.AccountHierarchy}/GetAccountHierarchyDataByParentIds`, params)
  }
  GetItemHierarchyDataByParentIds = (params: any) => {
    return this.http.post<any>(`${this.environment.ItemHierarchy}/GetItemHierarchyDataByParentIds`, params)
  }
  ItemAccountCombinationGetAll(params: any): Observable<any> {
    return this.http.post<any>(`${this.environment.RunningWeekAccSetting}/GetAll`, params);
  }
  UpdateItemAccount(params: any): Observable<any> {
    return this.http.post(
      `${this.environment.RunningWeekAccSetting}/Update`,
      params
    );
  }
  AddItemAccount(body: any): Observable<any> {
    return this.http.post(
      `${this.environment.RunningWeekAccSetting}/Add`,
      body
    );
  }
  DeleteItemAccount(body: any): Observable<any> {
    return this.http.post(
      `${this.environment.RunningWeekAccSetting}/Delete`,
      body
    );
  }
  ExportRunningWeek(params: any): Observable<any> {
    return this.http.post(`${this.environment.RunningWeekAccSetting}/Export`, params, {
      observe: 'response',
      responseType: 'blob',
    });
  }
  DeleteRunningWeekItemAccount(params: any): Observable<any> {
    return this.http.post(`${this.environment.RunningWeekAccSetting}/BulkDelete`, params);
  }
  ConfigBulkUpload(params: any): Observable<any> {
    var formData = new FormData();
    formData.append('file', params.file);
    formData.append('userName', params.userName);
    formData.append('documentType', params.documentType);
    formData.append('userId', params.userId);
    return this.http.post<Array<any>>(
      `${this.environment.RunningWeekAccSetting}/Import`,
      formData
    );
  }
  AccountSettingcommit(): Observable<any> {
    return this.http.get(`${this.environment.RunningWeekAccSetting}/Commit`);
  }

  fetchRetailCalendarData(): Promise<any> {
    return new Promise((resolve) => {
      if (this.retailCalendarData.length) {
        resolve(this.retailCalendarData);
      } else {
        this.http.get(`${this.environment.AppCommonCode}/getCalendar`)
          .subscribe((res: any) => {
            this.retailCalendarData = res;
            resolve(this.retailCalendarData);
          },
            (err: any) => {
              resolve([]);
            });
      }
    });
  }
  // Master API's

  GetAllConfiguartions = (query: any) => {
    return this.http.post<any>(
      `${this.environment.MasterConfiguration}/GetAll`, query
    );
  };
  AddConfiguration = (data: any) => {
    return this.http.post<any>(`${this.environment.MasterConfiguration}/Add`, data);
  };
  UpdateConfiguration = (data: any) => {
    return this.http.put(`${this.environment.MasterConfiguration}/Update`, data);
  };

  /* This will be used to fetch all of the lists  */
  GetStoreMasterList(): Observable<any> {
    return this.http.get(`${this.environment.StoreMaster}/GetList`);
  }

  /* This will be used to fetch the list using pagination  */
  GetAllStoreMaster(payload: string): Observable<any> {
    return this.http.post(`${this.environment.StoreMaster}/GetAll`, payload);
  }

  GetStoreById(storeId: number): Observable<any> {
    return this.http.get(`${this.environment.StoreMaster}/Get`, {
      params: { storeId: storeId.toString() }
    });
  }

  AddStoreMaster(payload: any): Observable<any> {
    return this.http.post(`${this.environment.StoreMaster}/Add`, payload);
  }

  UpdateStoreMaster(payload: any): Observable<any> {
    return this.http.put(`${this.environment.StoreMaster}/Update`, payload);
  }

  GetAllCalendar = (params: any) => {
    return this.http.get<any>(`${this.environment.CalendarHierarchy}/GetAllCalendar`, { params })
  }
  // Product Master
  GetAllProducts = (params: any) => {
    return this.http.post<any>(
      `${this.environment.ProductMaster}/GetAll`, params
    );
  };
  AddProduct = (data: any) => {
    return this.http.post<any>(`${this.environment.ProductMaster}/Add`, data);
  };
  UpdateProduct = (data: any) => {
    return this.http.put(`${this.environment.ProductMaster}/Update`, data);
  };

  GetMasterConfigByType = (params: any) => {
    return this.http.get<any>(
      `${this.environment.MasterConfiguration}/GetByType`, { params }
    );
  };

  PromoMasterGetAll = (params: any) => {
    return this.http.post<any>(`${this.environment.PromoMaster}/GetAll`, params)
  };
 PromoMasterList(): Observable<any> {
    return this.http.get(`${this.environment.PromoMaster}/GetList`);
  }
  PromoMasterUpdate = (data: any) => {
    return this.http.put(`${this.environment.PromoMaster}/Update`, data);
  };
  GetPromoEvent = (data: any) => {
    return this.http.post<any>(`${this.environment.PromoMaster}/GetPromoEvent`, data);
  };

  PromoMasterAdd = (data: any) => {
    return this.http.post(`${this.environment.PromoMaster}/Add`, data);
  };

  UpdatePromoDetails = (data: any) => {
    return this.http.post(`${this.environment.PromoMaster}/UpdatePromoDetails`, data);
  };


  PromoDetails = (params: any) => {
    return this.http.post<any>(`${this.environment.PromoMaster}/GetPaginatedPromoDetails`, params)
  };

  // Master Export
  ExportMasterData(params: any): Observable<any> {
    return this.http.post(`${this.environment.MasterConfiguration}/Export`, params, {
      observe: 'response',
      responseType: 'blob',
    });
  }

  // Price Master
  GetAllPrice = (params: any) => {
    return this.http.post<any>(
      `${this.environment.PriceMaster}/GetAll`, params
    );
  };
  AddPrice = (data: any) => {
    return this.http.post<any>(`${this.environment.PriceMaster}/Add`, data);
  };
  UpdatePrice = (data: any) => {
    return this.http.put(`${this.environment.PriceMaster}/Update`, data);
  };

  GetAllVendors = (query: any) => {
    return this.http.post<any>(
      `${this.environment.VendorMaster}/GetAll`, query
    );
  };

  GetListVendorMaster = (): Observable<any> => {
    return this.http.get<any>(`${this.environment.VendorMaster}/GetList`);
  }

  GetVendorProducts = (query: any) => {
    return this.http.post<any>(
      `${this.environment.VendorMaster}/GetPaginatedVendorProducts`, query
    );
  };
  AddVendor = (data: any) => {
    return this.http.post<any>(`${this.environment.VendorMaster}/Add`, data);
  };
  UpdateVendor = (data: any) => {
    return this.http.put(`${this.environment.VendorMaster}/Update`, data);
  };
  GetJobTypes = () => {
    return this.http.get<any>(`${this.environment.VendorMaster}/GetJobTypes`);
  }
  GetJobOrderTypes = () => {
    return this.http.get<any>(`${this.environment.VendorMaster}/GetJobOrderTypes`);
  }
  GetListVendorMOVMOQ = (vendorId: number) => {
    return this.http.get<any>(`${this.environment.VendorMaster}/GetVendorOrderTypes?VendorID=${vendorId}`);
  }
  DeleteMOVMOQ = (data: any) => {
    return this.http.post<any>(`${this.environment.VendorMaster}/DeleteMOVMOQ`, data);
  };
  AddMOVMOQ = (data: any) => {
    return this.http.post<any>(`${this.environment.VendorMaster}/AddMOVMOQ`, data);
  };
  UpdateMOVMOQ = (data: any) => {
    return this.http.put(`${this.environment.VendorMaster}/UpdateMOVMOQ`, data);
  };
  BulkUpdateConfiguration = (data: any) => {
    return this.http.post<any>(`${this.environment.MasterConfiguration}/BulkUpdate`, data);
  };
  // DC Master
  GetAllDC = (params: any) => {
    return this.http.post<any>(
      `${this.environment.DCMaster}/GetAll`, params
    );
  };

  GetListDC = (): Observable<any> => {
    return this.http.get<any>(
      `${this.environment.DCMaster}/GetList`
    );
  };

  AddDC = (data: any) => {
    return this.http.post<any>(`${this.environment.DCMaster}/Add`, data);
  };
  UpdateDC = (data: any) => {
    return this.http.put(`${this.environment.DCMaster}/Update`, data);
  };

  getGrainTemplateId(): Observable<AccountGrainInfo[]> {
    return this.http.get<AccountGrainInfo[]>(`${this.environment.AppCommonCode}/GetGrainTemplateId`);
  }

  PromoGetUpliftDecayList = (params: any) => {
    return this.http.post<any>(`${this.environment.DePromoManager}/GetAll`, params)
  };

  GetPromoEventNameList = () => {
    return this.http.get(`${this.environment.Lookup}/GetPromoEventNameList`);
  }

  GetHistoricalPromoNameList = (noOfWeeks: number) => {
    return this.http.get(`${this.environment.Lookup}/GetHistoricalPromoNameList?noOfWeeks=${noOfWeeks}`);
  }

  GetAllPromotionItemsById = (obj: any) => {
    return this.http.post(`${this.environment.DePromoManager}/GetAllById`, obj);
  }

  UpdatePromoUpliftDecay = (obj: any) => {
    return this.http.post(`${this.environment.DePromoManager}/UpdatePromo`, obj);
  }

  GetDepromoPipelineStatus = () => {
    return this.http.post(`${this.environment.DePromoManager}/SynchDepromo`, {});
  }

  GetSyncDepromoPipelineStatus = () => {
    return this.http.post(`${this.environment.DePromoManager}/GetSynchStatus`, {});
  }

  GetPromoPerformance = (obj: any) => {
    return this.http.post(`${this.environment.DePromoManager}/GetPromoPerformance`, obj);
  }

  UpdatePromoMeasures = (obj: any) => {
    return this.http.post(`${this.environment.DePromoManager}/UpdatePromoMeasures`, obj);
  }

  masterImport(params: any): Observable<any> {
    var formData = new FormData();
    formData.append('file', params.file);
    formData.append('masterType', params.masterType);
    formData.append('userId', params.userId);
    return this.http.post<Array<any>>(
      `${this.environment.MasterConfiguration}/Import`,
      formData
    );
  }

  importVendorOrderType(params: any): Observable<any> {
    var formData = new FormData();
    formData.append('file', params.file);
    formData.append('userId', params.userId);
    return this.http.post<any>(
      `${this.environment.MasterConfiguration}/ImportVendorOrderType`,
      formData
    );
  }
  CreateSplitPlannerTable = (body: any) => {
    return this.http.post<any>(
      `${this.environment.AppFBForcast}/fbForecastCreateSplitPlannerTable`, body);
  };

  // Ranging Family
  GetAllFamilyGrade = (query: any) => {
    return this.http.post<any>(
      `${this.environment.ReplenishmentPOG}/GetAllFamilyGrade`, query
    );
  };

  ImportFamilyGrade(params: any): Observable<any> {
    var formData = new FormData();
    formData.append('file', params.file);
    formData.append('userId', params.userId);
    return this.http.post<Array<any>>(
      `${this.environment.ReplenishmentPOG}/ImportFamilyGrade`,
      formData
    );
  }

  GetPlannersByCoreArea = (params: any) => {
    return this.http.get<any>(
      `${this.environment.KPIList}/GetPlannersByCoreArea`, { params }
    );
  };
  GetNextRollingDate = (params: any) => {
    return this.http.post<any>(
      `${this.environment.KPISubscription}/GetNextRollingDate`, params
    );
  };
  LoadMeasureValue = (params: any) => {
    return this.http.post<any>(
      `${this.environment.KPISubscription}/LoadMeasureValue`, params
    );
  };

  journeyCollaborationAdd = (body: any) => {
    return this.http.post<any>(
      `${this.environment.AppJourneyCollaboration}/AddNew`, body);
  };

  journeyCollaborationUpdate = (body: any) => {
    return this.http.put<any>(
      `${this.environment.AppJourneyCollaboration}/Update`, body);
  };

  journeyCollaborationAddContextBulk = (body: any) => {
    return this.http.post<any>(
      `${this.environment.AppJourneyCollaboration}/AddMultiContexts`, body);
  };
  GetNonRangedOrderItems(params: any): Observable<any> {
    return this.http.post<any>(`${this.environment.AppItemManager}/GetNonRangedOrderAbleItems`, params);
  }
  AddPlannerJob = (body: any) => {
    return this.http.post<any>(
      `${this.environment.PlannerJob}/AddPlannerJob`,
      body
    );
  };
  AddSimulateJob = (body: any) => {
    return this.http.post<any>(
      `${this.environment.PlannerJob}/AddSimulateJob`,
      body
    );
  };
  GetSimulateJob = (params: any) => {
    return this.http.get<any>(
      `${this.environment.PlannerJob}/GetSimulateJob`, { params }
    );
  };
  GetMergeProductJob = (params: any) => {
    return this.http.get<any>(
      `${this.environment.ProductReplacement}/GetPlannerReplacementCalcStatus`, { params }
    );
  };
  AddMergeProductJob = (body: any) => {
    return this.http.post<any>(
      `${this.environment.ProductReplacement}/ReCalculatePlannerReplacement`,
      body
    );
  };
  UpdateSimulateJobStatusByUser = (body: any) => {
    return this.http.put<any>(
      `${this.environment.PlannerJob}/UpdateSimulateJobStatusByUser`,
      body
    );
  };
  DeleteSimulateJobRecords = (body: any) => {
    return this.http.post<any>(
      `${this.environment.PlannerJob}/DeleteSimulateJobRecords`,
      body
    );
  };
  GetPlannerJobs = (params: any) => {
    return this.http.get<any>(
      `${this.environment.PlannerJob}/GetPlannerJob`, { params }
    );
  };
  ApprovalsAdd = (body: any) => {
    return this.http.post<any>(
      `${this.environment.Approvals}/Add`,
      body
    );
  };
  ApprovalList(params: any): Observable<any> {
    return this.http.get(`${this.environment.Approvals}/getList`, {
      params,
    });
  }
  ApprovalResponse = (body: any) => {
    return this.http.post<any>(
      `${this.environment.NotificationsApi}/ApprovalResponse`,
      body
    );
  };
  GetApprovalByRequestId(params: any): Observable<any> {
    return this.http.get(`${this.environment.Approvals}/GetApprovalByRequestId`, {
      params,
    });
  }
  GetAllApprovals(params: any): Observable<any> {
    return this.http.post(`${this.environment.Approvals}/GetAll`, params);
  }
   GetAllPaginatedReportList = () => {
    return this.http.get<any>(`${this.environment.PaginatedReportExtraction}/PaginatedReportGetList`);
  }
  //Package Manager APIs
  PackManagerGetList = (params: any) => {
    return this.http.get<any>(`${this.environment.PackManager}/GetList`, params);
  };
  AddPack = (body: any) => {
    return this.http.post<any>(`${this.environment.PackManager}/Add`, body);
  };
  ModifyPack = (body: any) => {
    return this.http.put(`${this.environment.PackManager}/Update`, body);
  };
  DeletePack = (body: any) => {
    return this.http.put(`${this.environment.PackManager}/UpdateStatus`, body);
  };
  ApprovalActivate(params: any): Observable<any> {
    return this.http.post(`${this.environment.Approvals}/Activate`,  params );
  }

  PaginatedReportJobGetBySchedulerId(params: any): Observable<any> {
    return this.http.get(`${this.environment.PaginatedReportExtraction}/PaginatedReportJobGetBySchedulerId`, {
      params: { schedulerId: params },
    });
  }
  GetApproval(params: any): Observable<any> {
    return this.http.get(`${this.environment.Approvals}/getApproval`, {
      params,
    });
  }
  DateKeywordGetAll(params: any): Observable<any> {
    return this.http.get(`${this.environment.RptfLookup}/DateKeywordGetAll`, {
      params,
    });
  }
  UpdateApprovalById = (body: any) => {
    return this.http.post(`${this.environment.Approvals}/UpdateApprovalById`, body);
  };
  UpdateApproval = (body: any) => {
    return this.http.put(`${this.environment.Approvals}/UpdateApproval`, body);
  };
  UpdateStatusByJourneyId = (body: any) => {
    return this.http.post(`${this.environment.Approvals}/UpdateStatusByJourneyId`, body);
  };
  GetAllProductFamily = (): Observable<any> => {
    return this.http.get<any>(`${this.environment.ProductMaster}/GetAllFamily`);
  }
  
  ExportReplPLanner(params: any): Observable<any> {
    return this.http.post(`${this.environment.AppFBForcast}/ReplExport`, params);
  }
  GetItemHierarchyByIHId = (params: any) => {
    return this.http.get<any>(`${this.environment.ItemHierarchy}/GetItemHierarchyByIHId`, { params })
  }
}